const defaultGermanMessages = {
  date: {
    defaultDateFormat: "dd.MM.yyyy",
    defaultDateTimeFormat: "dd.MM.yyyy kk:mm:ss",
    dateInputPattern: "##.##.####",
  },
  ra: {
    action: {
      add_filter: "Filter hinzufügen",
      add_price_position: "Position hinzufügen",
      add: "Hinzufügen",
      accept: "Akzeptieren",
      back: "Zurück",
      bulk_actions: "Ein Element ausgewählt |||| %{smart_count} Elemente ausgewählt",
      cancel: "Abbrechen",
      clear_input_value: "Eingabe löschen",
      clear_array_input: "Listeneingabe löschen",
      clone: "Klonen",
      close: "Schließen",
      close_menu: "Menü schließen",
      confirm: "Bestätigen",
      create: "Erstellen",
      create_item: "Eintrag anlegen",
      delete: "Löschen",
      download: "Herunterladen",
      edit: "Bearbeiten",
      expand: "Expandieren",
      export: "Exportieren",
      list: "Liste",
      move_down: "Nach unten bewegen",
      move_up: "Nach oben bewegen",
      open: "Öffnen",
      open_menu: "Menü öffnen",
      reset: "Zurücksetzen",
      refresh: "Aktualisieren",
      remove_filter: "Filter entfernen",
      remove_all_filters: "Alle Filter entfernen",
      remove: "Entfernen",
      save: "Speichern",
      search: "Suchen",
      search_columns: "Spalten durchsuchen",
      select_all: "Alles auswählen",
      select_all_button: "Alles auswählen",
      select_row: "Eintrag auswählen",
      select_columns: "Spalten",
      send: "Versenden",
      show: "Anzeigen",
      sort: "Sortieren",
      toggle_theme: "Theme ändern",
      undo: "Zurücksetzen",
      unselect: "Abwählen",
      update: "Aktualisieren",
      update_application: "Anwendung aktualisieren",
    },
    boolean: {
      true: "Ja",
      false: "Nein",
      null: " ",
    },
    page: {
      list: "%{name}",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "%{name} erstellen",
      loading: "Lädt",
      dashboard: "Dashboard",
      not_found: "Nicht gefunden",
      error: "Etwas ist schief gelaufen",
      empty: "Noch nichts vorhanden.",
      invite: "Soll etwas daran geändert werden?",
      access_denied: "Zugriff verweigert",
      authentication_error: "Fehler bei der Authentifizierung",
    },
    sort: {
      ASC: "aufsteigend",
      DESC: "absteigend",
      sort_by: "%{field}",
    },
    input: {
      file: {
        upload_several: "Zum Hochladen Dateien hineinziehen oder hier klicken, um Dateien auszuwählen.",
        upload_single: "Zum Hochladen Datei hineinziehen oder hier klicken, um eine Datei auszuwählen.",
      },
      image: {
        upload_several: "Zum Hochladen Bilder hineinziehen oder hier klicken, um Bilder auszuwählen.",
        upload_single: "Zum Hochladen Bild hineinziehen oder hier klicken, um ein Bild auszuwählen.",
      },
      password: {
        toggle_visible: "Passwort verstecken",
        toggle_hidden: "Passwort anzeigen",
      },
      references: {
        all_missing: "Die zugehörigen Referenzen konnten nicht gefunden werden.",
        many_missing: "Mindestens eine der zugehörigen Referenzen scheint nicht mehr verfügbar zu sein.",
        single_missing: "Eine zugehörige Referenz scheint nicht mehr verfügbar zu sein.",
      },
    },
    message: {
      yes: "Ja",
      no: "Nein",
      are_you_sure: "Sicher?",
      about: "Über",
      auth_error: "Bitte einloggen um fortzufahren",
      not_found: "Die Seite konnte nicht gefunden werden.",
      loading: "Die Seite wird geladen.",
      invalid_form: "Das Formular ist ungültig. Bitte Eingaben überprüfen.",
      delete_title: "Löschen",
      delete_content: "Soll dieser Inhalt wirklich gelöscht werden?",
      bulk_delete_title: "Löschen bestätigen",
      bulk_delete_content:
        "Soll dieses Element wirklich gelöscht werden? |||| Sollen diese %{smart_count} Elemente wirklich gelöscht werden?",
      bulk_update_content:
        "Soll dieses Element wirklich aktualisiert werden? |||| Sollen diese %{smart_count} Elemente aktualisiert werden?",
      bulk_update_title: "Aktualisieren bestätigen",
      clear_array_input: "Soll wirklich die ganze Liste gelöscht werden?",
      details: "Details",
      error: "Ein Fehler ist aufgetreten und die Anfrage konnte nicht abgeschlossen werden.",
      unsaved_changes: "Manche Änderungen wurden nicht gespeichert. Wirklich ignorieren?",
      delete_failed_must_archive: "Das Löschen ist nicht möglich, bitte archivieren.",
      access_denied: "Zugriff verweigert",
      authentication_error: "Fehler bei der Authentifizierung",
      select_all_limit_reached: "Maximale Anzahl für Auswahl erreicht",
      placeholder_data_warning: "Netzwerkproblem: Datenaktualisierung fehlgeschlagen.",
    },
    navigation: {
      no_results: "Noch keine vorhanden",
      no_more_results: "Die Seite %{page} enthält keine Inhalte.",
      page_out_of_boundaries: "Die Seite %{page} liegt ausserhalb des gültigen Bereichs",
      page_out_from_end: "Letzte Seite",
      page_out_from_begin: "Erste Seite",
      page_range_info: "%{offsetBegin}-%{offsetEnd} von %{total}",
      page_rows_per_page: "Zeilen pro Seite:",
      next: "Weiter",
      prev: "Zurück",
      previous: "Zurück",
      skip_nav: "Zum Inhalt",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}",
      current_page: "Seite %{page}",
      page: "Seite %{page}",
      first: "Erste Seite",
      last: "Letzte Seite",
      no_filtered_results: "Für diese Filter konnten keine Ergebnisse gefunden werden.",
      clear_filters: "Alle Filter zurücksetzen",
    },
    auth: {
      auth_check_error: "Bitte einloggen um fortzufahren",
      user_menu: "Profil",
      username: "E-Mail",
      email: "E-Mail",
      password: "Passwort",
      sign_in: "Anmelden",
      sign_in_error: "Fehler bei der Anmeldung",
      logout: "Abmelden",
    },
    notification: {
      i18n_error: "Übersetungen für die ausgewählte Sprache nicht vorhanden.",
      not_authorized: "Kein Zugriff auf diesen Inhalt.",
      updated: "Element wurde aktualisiert |||| %{smart_count} Elemente wurden aktualisiert",
      created: "Element wurde erstellt",
      deleted: "Element wurde gelöscht |||| %{smart_count} Elemente wurden gelöscht",
      bad_item: "Fehlerhaftes Element",
      item_doesnt_exist: "Das Element existiert nicht",
      http_error: "Fehler beim Kommunizieren mit dem Server",
      data_provider_error: "dataProvider Fehler. Prüfe die Konsole für Details.",
      canceled: "Aktion abgebrochen",
      logged_out: "Abgemeldet. Bitte erneut anmelden.",
      application_update_available: "Aktualisierung verfügbar",
      offline: "Offline",
    },
    validation: {
      required: "Benötigt",
      minLength: "Muss mindestens %{min} Zeichen lang sein",
      maxLength: "Darf maximal %{max} Zeichen lang sein",
      minValue: "Muss mindestens %{min} sein",
      maxValue: "Muss %{max} oder weniger sein",
      number: "Muss eine Nummer sein",
      email: "Muss eine gültige E-Mail sein",
      oneOf: "Es muss einer sein von: %{options}",
      regex: "Es muss folgendem regulären Ausdruck entsprechen: %{pattern}",
      not_unique: "wird bereits verwendet",
      unique: "Muss eindeutig sein",
    },
    saved_queries: {
      label: "Gespeicherte Filter",
      query_name: "Filtername",
      new_label: "Aktuellen Filter speichern...",
      new_dialog_title: "Aktuellen Filter speichern unter",
      remove_label: "Gespeicherten Filter entfernen",
      remove_label_with_name: 'Gespeicherten Filter "%{name}" entfernen',
      remove_dialog_title: "Gespeicherten Filter entfernen?",
      remove_message: "Soll dieser Eintrag wirklich aus der Liste von gespeicherten Filtern gelöscht werden?",
      help: "Liste filtern und Filtereinstellung speichern",
    },
    configurable: {
      customize: "Personalisieren",
      templateError: "## Template Fehler",
      configureMode: "Diese Seite Konfigurieren",
      inspector: {
        title: "Inspektor",
        content: "Anwendungs-Elemente auswählen, um diese zu personalisieren",
        reset: "Einstellungen zurücksetzen",
        hideAll: "Alle verstecken",
        showAll: "Alle anzeigen",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Primärer Text",
        secondaryText: "Sekundärer Text",
        tertiaryText: "Tertiärer Text",
      },
      Datagrid: {
        title: "Datentabelle",
        unlabeled: "Unbenannte Spalte #%{column}",
      },
      SimpleForm: {
        title: "Formular",
        unlabeled: "Unbenanntes Feld #%{input}",
      },
    },
  },
};

const userFields = {
  id: "ID",
  image_path: "Bildpfad",
  lecturer_fee: "Vergütung",
  user_custom_fields_data: "Erweiterte Felder",
  is_unverified: "Neu",
  guest: "Gast",
  title: "Titel",
  first_name: "Vorname",
  last_name: "Nachname",
  full_name: "Name",
  gender: "Geschlecht",
  birthday: "Geburtsdatum",
  address: "Adresse",
  main_contact_info: "Kommunikation",
  invoice_contact_info: "Rechnung",
  invoice_dispatch_contact_info: "Rechnungsversand",
  main_contact_info__email: "E-Mail (Kommunikation)",
  main_contact_info__organization_name: "Organisationsname (Kommunikation)",
  main_contact_info__city: "Stadt (Kommunikation)",
  main_contact_info__postcode: "PLZ (Kommunikation)",
  login_email: "Login E-Mail",
  auth_user__email: "Login E-Mail",
  lecturer__common_fee: "Vergütung (€)",
  attendee__attendee_number: "Kundennummer",
  contact_types: "Art der Kontaktinformation",
  debit_number: "Debitorennummer",
  audience_role: "Zielgruppe",
  common_fee: "Vergütung (€)",
  description: "Beschreibung",
  qualifications: "Qualifikationen",
  categories: "Kategorien",
  image: "Bild",
  documents: "Dokumente",
  created_at: "Erstellt",
  contact_info: {
    id: "ID",
    email: "E-Mail",
    phone: "Telefon",
    mobile: "Mobil",
    fax: "Fax",
    website: "Webseite",
    organization_name: "Organisationsname",
    address_line_1: "Adresszeile 1",
    address_line_2: "Adresszeile 2",
    co: "c/o",
    postcode: "PLZ",
    countrycode: "Ländercode",
    city: "Stadt",
    state: "Bundesland",
    country: "Land",
  },
  tags: "Schlagworte",
  language: "Sprache",
  lists: "Abonnierte Listen",
  organization_names: "Zugewiesene Organisationen",
  accounts: "Konten",
};

const userAndEnrollmentFilters = {
  emails: "E-Mails",
  qualifications: "Qualifikationen",
  categories: "Kategorien",
  event_base_categories: "Angebots-Kategorien",
};

const customFieldContentTypeName = "Erweitertes Feld |||| Erweiterte Felder";

const germanMessages = {
  ...defaultGermanMessages,
  resources: {
    applications: {
      name: "OAuth-Anwendung |||| OAuth-Anwendungen",
    },
    event_attendances: {
      name: "Teilnahme |||| Teilnahmen",
      fields: {
        comment: "Kommentar",
        has_attended: "Teilgenommen",
      },
      actions: {
        add_absence: "Fehlzeit hinzufügen",
        edit_absence: "Fehlzeit bearbeiten",
        add_comment: "Kommentar hinzufügen",
        edit_comment: "Kommentar bearbeiten",
        mark_attended: "Als teilgenommen markieren",
        mark_unattended: "Als fehlend markieren",
      },
      hints: {
        has_attended: "Teilgenommen",
        has_not_attended: "Nicht teilgenommen",
        has_attended_count: "An %{attendedCount} von %{attendedMax} Unterveranstaltungen teilgenommen",
        attendance_unknown: "Teilnahme unbekannt",
      },
    },
    attendance_absences: {
      name: "Fehlzeit |||| Fehlzeiten",
      fields: {
        absence_start: "Beginn der Fehlzeit",
        absence_end: "Ende der Fehlzeit",
      },
      validation: {
        start_time_before: "Beginn der Fehlzeit muss früher sein als %{maxTime}",
        start_time_after: "Beginn der Fehlzeit muss später sein als %{minTime}",
        end_time_after: "Ende der Fehlzeit muss früher sein als %{maxTime}",
        start_time_before_end_time: "Beginn der Fehlzeit muss vor Ende der Fehlzeit sein",
        end_time_after_start_time: "Ende der Fehlzeit muss vor Beginn der Fehlzeit sein",
      },
    },
    attendees: {
      name: "Teilnehmer*in |||| Teilnehmende",
      fields: { ...userFields, with: "Teilmehmer*in", attendee_number: "Kundennummer" },
      actions: {
        update_contact_infos: "Kontaktinformationen aktualisieren",
        add_main_contact_info: "Kommunikation",
        add_invoice_contact_info: "Rechnung",
        add_invoice_dispatch_contact_info: "Rechnungsversand",
        enroll_to_moodle_courses: "In Moodle-Kurs(e) einbuchen",
        add_new_interested: "Neue Interessent*in anlegen",
        add_new: "Neue Person anlegen",
        add_existing: "Bestehende Personen",
        copy_main_contact_info: "Kommunikationsanschrift übernehmen",
        show_more_fields: "Weitere Felder anzeigen",
        add_to_list: "Zu Liste hinzufügen",
        add_to_organization: "Zu Organisation hinzufügen",
      },
      is_archived: "Person ist archiviert",
      removed: "Person ist gelöscht",
      hints: {
        booking_documents_at_booking: "Buchungsdokumente befinden sich an der jeweiligen Buchung.",
        debit_number_taken:
          "wird bereits von einer anderen Person oder Organisation verwendet. Bitte sicherstellen, dass das gewünscht ist.",
        debit_number_outside_range: "Debitorennummer %{debit_number} liegt außerhalb des Debitorenkreises %{range}.",
        debit_number_range_open: "ab %{start}",
      },
    },
    audiences: {
      name: "Zielgruppe |||| Zielgruppen",
      fields: {
        name: "Name",
      },
    },
    auth_groups: {
      name: "Berechtigungsgruppe |||| Berechtigungsgruppen",
    },
    customer: {
      name: "Kundenprofil |||| Kundenprofil",
      fields: {
        name: "Name",
        value_added_tax_id: "Umsatzsteuer-Identifikationsnummer",
        trade_register_number: "Handelsregisternummer",
        fiscal_number: "Steuernummer",
        iban: "IBAN",
      },
      hints: {
        no_customer_created_yet: "Es wurde noch kein Kundenprofil angelegt.",
      },
      sections: {
        general: "Allgemein",
        invoicing: "Rechnungsstellung",
      },
    },
    contacts: {
      name: "Kontakt |||| Kontakte",
    },
    contact_persons: {
      name: "Kontaktperson |||| Kontaktpersonen",
    },
    user_roles: {
      name: "Berechtigungsgruppe |||| Berechtigungsgruppen",
      fields: {
        name: "Name",
        permission_groups: "Berechtigungen",
      },
      auth_groups: {
        default: "Oberflächen-Zugriff",
        manage_events: "Veranstaltungen verwalten",
        manage_event_bases: "Angebote verwalten",
        manage_orders: "Bestellungen verwalten",
        manage_users: "Personen verwalten",
        manage_attendees: "Teilnehmende verwalten",
        manage_interests: "Interessenten verwalten",
        manage_lecturers: "Dozierende verwalten",
        manage_todos_and_responsibilities: "Aufgaben & Zuständigkeiten verwalten",
        manage_bookings: "Buchungen verwalten",
        manage_moodle: "Moodle verwalten",
        manage_invoices: "Rechnungen verwalten",
        manage_access: "EDM-Zugriff verwalten",
        manage_templates: "Vorlagen verwalten",
        manage_settings: "Einstellungen verwalten",
        manage_base_data: "Stammdaten verwalten",
        manage_organizations: "Organisationen verwalten",
        view_accounting: "EDM-Abrechnung einsehen",
        view_reporting: "Auswertung einsehen",
        view_booking_list: "Buchungsliste einsehen",
        view_invoice_list: "Rechnungsliste einsehen",
        manage_accounting: "Finanzbuchhaltung",
        manage_event_feedback: "Veranstaltungs-Feedback verwalten",
        view_feedback_report: "Feedback-Auswertung einsehen",
        attendee: "Berechtigungen für Teilnehmende",
        lecturer: "Berechtigungen für Dozierende",
      },
      headlines: {
        permission_info: "Beschreibung der Berechtigungen",
      },
    },
    auth_users: {
      name: "Login",
      fields: {
        email: "E-Mail",
      },
    },
    bookings: {
      name: "Buchung |||| Buchungen",
      fields: {
        event_date_attendances: "Anwesenheit",
        has_attended: "Teilgenommen",
        price_positions: "Preispositionen",
        attendee: "Teilnehmer*in",
        booking_number: "Buchungsnummer",
        status: "Status",
        created_at: "Eingebucht am",
        format: "Teilnahmeformat",
        first_name: "Vorname",
        last_name: "Nachname",
        event: "Veranstaltung",
        event_id_number: "Veranstaltungs-Nummer",
        amount: "Betrag",
        price: "Preis",
        invoices: "Rechnung",
        invoiced_amount: "Abgerechneter Betrag",
        price_amount: "Betrag",
        price_name: "Preisname",
        attendee__last_name: "Nachname",
        price__price_type__name: "Preistyp",
        order_item__order__order_number: "Bestellnummer",
        order: "Bestellung",
      },
      calculated_fields: {
        paid: "bezahlt",
        attended: "Teilgenommen",
      },
      actions: {
        cancel_order_item: "Bestellposition stornieren |||| Bestellpositionen stornieren",
        cancel_bookings: "Buchung stornieren |||| Buchungen stornieren",
        cancel_bookings_count: "Buchung stornieren |||| %{smart_count} Buchungen stornieren",
        invoices_menu: "Rechnung",
        change_status: "Status ändern",
        create_invoices: "Rechnung erstellen |||| Rechnungen erstellen",
        download_invoices: "Rechnung herunterladen |||| Rechnungen herunterladen",
        send_invoices: "Rechnung versenden |||| Rechnungen versenden",
        delete_invoices: "Rechnung löschen |||| Rechnungen löschen",
        edit_invoices: "Rechnung bearbeiten |||| Rechnungen bearbeiten",
        send_mail_to_all_bookings: "E-Mail an alle",
        send_mail_to_all_bookings_VALID: "%{bookingCount} eingebuchte Personen",
        send_mail_to_all_bookings_WAITING: "%{bookingCount} wartende Personen",
        send_mail_to_all_bookings_CANCELED: "%{bookingCount} stornierte Personen",
        send_mail_to_all_lecturers: "%{lecturerCount} Dozierende",
        edit_attendance: "Teilnahme bearbeiten",
        mark_as_attended: "Als teilgenommen markieren",
        mark_as_unattended: "Als nicht teilgenommen markieren",
        add_as_interests: "Als Interessiert hinzufügen",
        alter_bookings: "Umbuchen",
        use_existing_price_type: "Gleichen Preistyp verwenden",
        create_correction_invoice: "Korrekturrechnung für die stornierte Position erstellen",
        use_custom_fields_data: "Erweiterte Buchungsfelder übernehmen",
        visit_website: "Auf Webseite anzeigen",
        bill_to_other: "Bestellung einer Organisation / anderen Person zuordnen",
        delete: "Buchung löschen |||| Buchungen löschen",
      },
      hints: {
        billing_unchanged:
          "Die bestehende Bestellposition wird der neuen Veranstaltung zugeordnet. Preis, Zahlungen und Rechnungen bleiben unverändert. Bereits erstellte Rechnungen nennen weiterhin die bisherige Veranstaltung.",
        rebill:
          "Die bisherige Bestellposition wird storniert und in derselben Bestellung durch eine neue Position mit dem unten gewählten Preis ersetzt. Bereits gezahlte Beträge werden nicht auf die neue Position übertragen. Für bereits berechnete Positionen kann eine Korrekturrechnung erstellt werden. Eine Rechnung für die neue Position bei Bedarf manuell erstellen.",
        rebill_prepaid: "Bei Vorkasse-Bestellungen nicht möglich, bitte separate Bestellung anlegen.",
        order_item_stays_active:
          "Die Bestellposition bleibt aktiv, zählt weiter als verkauft und steht weiter zur Abrechnung an. Stornieren kann sie nur, wer Bestellungen verwalten darf. |||| Die Bestellpositionen bleiben aktiv, zählen weiter als verkauft und stehen weiter zur Abrechnung an. Stornieren kann sie nur, wer Bestellungen verwalten darf.",
        status_locked_by_canceled_item_rebooked:
          "Die Bestellposition ist storniert, daher bleibt die Buchung umgebucht.",
        status_locked_by_canceled_item: "Die Bestellposition ist storniert, daher bleibt die Buchung storniert.",
        skipped_canceled_items:
          "%{smart_count} Buchung übersprungen, weil ihre Bestellposition storniert ist |||| %{smart_count} Buchungen übersprungen, weil ihre Bestellposition storniert ist",
        bookings_to_cancel: "%{smart_count} Buchung wird storniert. |||| %{smart_count} Buchungen werden storniert.",
        already_canceled:
          "%{smart_count} Buchung ist bereits storniert. |||| %{smart_count} Buchungen sind bereits storniert.",
        deleted: "Buchung gelöscht |||| Buchungen gelöscht",
        delete_explanation:
          "Die Buchung wird endgültig gelöscht und die zugehörige Bestellposition wieder als unverarbeitet geöffnet. |||| Die Buchungen werden endgültig gelöscht und die zugehörigen Bestellpositionen wieder als unverarbeitet geöffnet.",
        bill_to_other:
          "Standard: pro Person eine eigene Bestellung. Aktivieren, um alle Teilnehmenden in einer Bestellung zusammenzufassen und einer Organisation oder anderen Person in Rechnung zu stellen.",
        override_validation: "Verfügbarkeitsprüfungen (u. a. Kapazität) überspringen und Überbuchung zulassen.",
      },
      tooltips: {
        has_attended_event: "hat an Veranstaltung teilgenommen",
        has_attended_group_events: "hat an %{attendedCount} von %{attendedMax} Unterveranstaltungen teilgenommen",
      },
      labels: {
        created_at: "eingebucht am",
        rebooked_to: "umgebucht zu",
        rebooked_from: "umgebucht von",
        booking_data: "Buchungsdaten",
        fallback_price: "Preis, falls Preistyp fehlt",
        billing_mode: "Bestellposition",
        is_archived: "Diese Buchung ist archiviert",
        no_bookings: "Es sind keine Buchungen vorhanden.",
      },
      billing_modes: {
        UNCHANGED: "Bestellposition beibehalten",
        REBILL: "Bestellposition stornieren und eine neue anlegen",
      },
      status: {
        VALID: "Eingebucht",
        CANCELED: "Storniert",
        WAITING: "Warteliste",
        REBOOKED: "Umgebucht",
      },
    },
    categories: {
      name: "Kategorie |||| Kategorien",
      fields: {
        name: "Name",
        parent_category: "Überkategorie",
        parent_category_name: "Name der Überkategorie",
      },
      is_archived: "Diese Kategorie ist archiviert",
    },
    checkouts: {
      name: "Checkout |||| Checkouts",
      fields: {
        checkout_id: "Checkout-ID",
        payment_id: "Zahlungs-ID",
      },
    },
    consents: {
      name: "Einwilligung |||| Einwilligungen",
      fields: {
        is_confirmed: "Bestätigt",
        timestamp: "Erstellt am",
        order_number: "Bestellnummer",
        additional_info: "Zusätzliche Informationen",
      },
      hints: {
        confirmation_thank_you: "Vielen Dank fürs Bestätigen!",
      },
    },
    consent_types: {
      name: "Einwilligungstyp |||| Einwilligungstypen",
      fields: {
        name: "Name",
        scope: "Scope",
        needs_confirmation: "Benötigt Double-Opt-In",
        welcome_mail_template: "E-Mail-Vorlage nach Einwilligung",
        confirmation_mail_template: "E-Mail-Vorlage für Einwilligung",
        redirect_url: "Weiterleitungs-URL",
        description: "Beschreibung",
        show_in_registration_form: "In Registrierungsformular anzeigen",
        registration_text: "Text für Registrierungsformular",
      },
    },
    contexts: {
      name: "Umgebung |||| Umgebungen",
      fields: {
        name: "Name",
      },
    },
    content_types: {
      name: customFieldContentTypeName,
    },
    customer_invoices: {
      name: "Abrechnung |||| Abrechnung",
      fields: {
        id: "Abrechnungsnummer",
        to_datetime: "Buchungen bis",
        from_datetime: "Buchungen ab",
        minimum_price_per_month: "Mindestbetrag pro Monat",
        created_at: "Erstellt am",
        discount: "Rabatt",
        positions: "Buchungspositionen",
        commission_sum: "Provisionsbetrag",
        commission_per_month: "Fixe Provision pro Monat",
        invoice_sum: "Gesamtbetrag",
        attendee_name: "Teilnehmer*in",
        booking_number: "Buchungsnummer",
        order_number: "Bestellnummer",
        event_name: "Veranstaltung",
        booking_amount: "Buchungsbetrag",
        commission: "Provision",
        positions_count: "Anzahl Buchungspositionen",
      },
      labels: {
        minimum_amount: "Mindestbetrag",
      },
      filters: {
        negative_commission_only: "Nur negative Provisionsbeträge anzeigen",
      },
    },
    custom_field_select_values: {
      name: "Auswahlwerte (Erweiterte Felder)",
    },
    dashboard: {
      name: "Dashboard",
    },
    custom_fields_data: {
      name: customFieldContentTypeName,
      fields: {
        value: "Wert",
      },
    },
    descriptions: {
      name: "Beschreibung |||| Beschreibungen",
      fields: {
        id: "ID",
        text: "Text",
        slug: "Slug",
      },
    },
    document_templates: {
      name: "Dokumentvorlage |||| Dokumentvorlagen",
      label: "Dokumentvorlage",
      templateVersions: "Vorlagen Versionen",
      version: "Version %{version}",
      input: {
        upload_version: "Neue Version hochladen",
        store_permanently: "An %{scope} speichern",
        show_custom_content: "Individuellen Inhalt hinzufügen",
        hide_custom_content: "Individuellen Inhalt ausblenden",
        custom_content: "Individueller Inhalt",
      },
      actions: {
        showMoreVersions: "Alle Versionen anzeigen",
        showLessVersions: "Weniger",
        generate: "Dokumente erstellen",
        save_and_close: "Speichern & Schließen",
        save_and_send: "Speichern & Versenden",
        download_all: "Gebündelt herunterladen",
        example_menu: "Beispiele",
      },
      related_resource: {
        BOOKING_TEMPLATE: "Buchung",
        EVENT_TEMPLATE: "Veranstaltung",
        EVENT_BASE_TEMPLATE: "Angebot",
        ATTENDEE_TEMPLATE: "Teilnehmer*in",
        LECTURER_TEMPLATE: "Dozent*in",
        INVOICE_TEMPLATE: "Rechnung",
        ORGANIZATION_TEMPLATE: "Organisation",
        EVENT_LOCATION_TEMPLATE: "Veranstaltungsort",
      },
      fields: {
        original_filename: "Dateiname",
        related_resource: "Kontext",
        created_at: "Erstellt am",
        language: "Sprache",
        parent_template: "Übergeordnete Vorlage",
      },
      notification: {
        only_ms_word_files_allowed: "Ungültiger Dateityp. Erlaubt sind: .docx und .doc",
        successfully_generated:
          "%{smart_count} Dokument wurde erfolgreich generiert |||| %{smart_count} Dokumente wurden erfolgreich generiert",
        generation_finished: "Dokument wurde generiert |||| Dokumente wurden generiert",
        generation_in_progress: "Dokument wird generiert |||| Dokumente werden generiert",
        generation_other_pending:
          "%{smart_count} anderes Dokument wird zuerst generiert |||| %{smart_count} andere Dokumente werden zuerst generiert",
        generation_error: "Fehler beim Generieren des Dokuments |||| Fehler beim Generieren der Dokumente",
        persist_success: "Die Dokumente wurden dauerhaft gespeichert",
        persist_error: "Fehler beim Speichern der Dokumente",
        no_templates_present: "Es sind keine Vorlagen für diesen Bereich vorhanden.",
      },
      document_types: {
        participation_certificate: "Teilnahmebestätigung",
        name_plates: "Namensschilder",
      },
    },
    edm_moodle_enrollments: {
      name: "Moodle-Einbuchung |||| Moodle-Einbuchungen",
    },
    enrollments: {
      name: "Anmeldung |||| Anmeldungen",
      fields: {
        ...userFields,
        approval_url: "Freigabe-Link",
        approval_status: "Freigabe",
        approval_reason: "Begründung",
      },
    },
    orders: {
      name: "Bestellung |||| Bestellungen",
      fields: {
        id: "ID",
        status: "Status",
        order_number: "Bestellnummer",
        buyer: "Bestellt von",
        organization: "Organisation",
        user: "Bestellende Person",
        payment_provider: "Zahlungsart",
        is_paid: "Bezahlt",
        is_fully_invoiced: "Vollständig fakturiert",
        is_self_order: "Eigenbestellung",
        total: "Gesamtbetrag",
        buyer_note: "Notiz der bestellenden Person",
        your_note: "Ihre Notiz",
        note: "Ihre Notiz",
        open_items: "Offene Positionen",
        item_count: "Positionen",
        events: "Veranstaltungen",
        created_at: "Erstellt am",
      },
      filters: {
        has_processable_items: "Zu verarbeiten",
        person: "Besteller*in oder Teilnehmer*in",
        event: "Veranstaltung",
      },
      status: {
        pending: "Offen",
        confirmed: "Bestätigt",
        canceled: "Storniert",
      },
      payment_status: {
        pending: "Ausstehend",
        failure: "Fehlgeschlagen",
        completed: "Abgeschlossen",
      },
      checkout_failure_reason: {
        cancel_redirect:
          "Der Käufer hat den Bezahlvorgang abgebrochen. Die reservierten Plätze wurden wieder freigegeben.",
        expired_webhook: "Die Zahlungsfrist ist abgelaufen. Die reservierten Plätze wurden wieder freigegeben.",
      },
      payment_provider: {
        stripe: "Stripe",
        edm_invoice: "Rechnung",
      },
      buyer_type: {
        user: "Person",
        organization: "Organisation",
      },
      roles: {
        buying_person: "Bestellende Person",
        organization: "Bestellende Organisation",
        attendee: "Teilnehmende",
      },
      headlines: {
        custom_fields: "Zusätzliche Informationen",
        buyer: "Bestellt von",
        summary: "Übersicht",
        cancellation_email: "Stornierungs-E-Mail",
      },
      actions: {
        edit: "Bestellung bearbeiten",
        create: "Bestellung erstellen",
        confirm: "Bestätigen",
        cancel: "Stornieren",
        delete: "Bestellung löschen",
        create_invoice: "Rechnung erstellen",
        create_invoices: "Rechnungen erstellen",
        quick_book_all: "Direkt einbuchen (%{count})",
        quick_book: "Direkt einbuchen",
        override_validation: "Prüfungen überspringen",
        create_correction_invoice: "Korrekturrechnung erstellen",
        create_reversal_invoice: "Stornorechnung erstellen",
        create_correction_and_reversal_invoices: "Korrektur- und Stornorechnungen erstellen",
        refund: "Zahlung zurückerstatten",
        email_buyer: "E-Mail an Besteller*in",
        email_attendees: "E-Mail an Teilnehmende",
        email_buyers: "E-Mail an Bestellende",
        email_attendees_disabled:
          "Keine der ausgewählten Positionen hat eine Buchung - es gibt keine Teilnehmenden, die angeschrieben werden könnten.",
        resume_checkout: "Jetzt bezahlen",
      },
      hints: {
        invoice_canceled_order:
          "Die Bestellung ist storniert. Abgerechnet werden können nur freie Positionen, z. B. eine Stornogebühr.",
        ordered_at_by: "bestellt am %{date} von",
        ordered_at: "vom %{date}",
        confirmed: "Bestellung bestätigt",
        canceled: "Bestellung storniert",
        deleted: "Bestellung gelöscht",
        delete_explanation:
          "Die Bestellung wird mit allen Positionen endgültig gelöscht, als hätte sie nie existiert. Für eine tatsächlich stattgefundene Bestellung stattdessen stornieren.",
        delete_blocked:
          "Diese Bestellung kann nicht gelöscht werden, sondern nur storniert werden: Es existiert eine Rechnung, ein Zahlungsvorgang oder eine Buchung.",
        invoice_created: "Rechnung erstellt",
        invoice_ready: "Die Rechnung und ihr Dokument sind bereit.",
        invoice_document_failed:
          "Das Dokument konnte nicht generiert werden, daher wurde die Rechnung verworfen. Rechnungsvorlage prüfen und  Rechnung erneut erstellen.",
        document_ready: "Dokument bereit",
        document_missing: "Kein Dokument erstellt",
        skipped_item: "Position #%{id}: %{reason}",
        skipped_item_of_order: "%{order}: %{reason}",
        created: "Bestellung erstellt",
        buyer_without_billing_address:
          "Diese Person hat keine Rechnungsadresse (Straße, PLZ und Ort). Für die Bestellung kann keine Rechnung erzeugt werden.",
        processed: "Positionen gebucht",
        search: "Suchen",
        more_events: "Weitere Veranstaltungen",
        confirm_explanation: "Die Bestellung wird verbindlich. Buchungen werden erstellt und ggf. Rechnungen erzeugt.",
        confirm_prepaid_explanation:
          "Stripe-Bestellung: Ohne abgeschlossene Zahlung zu bestätigen erstellt die Buchungen und versendet die Bestätigungen sofort. Es wird keine Rechnung erzeugt. Eine spätere Zahlung wird weiterhin automatisch abgerechnet.",
        checkout_failed: "Zahlung fehlgeschlagen – Bestellung storniert",
        create_invoice_explanation: "Die folgenden Zeilen werden fakturiert:",
        bulk_create_invoice_explanation:
          "Die ausgewählten Buchungen werden je Bestellung zu einer Rechnung zusammengefasst (%{smart_count} Bestellung/en). Stornierte oder bereits fakturierte Positionen werden übersprungen.",
        bulk_create_order_invoice_explanation:
          "Je ausgewählter Bestellung wird eine Rechnung erstellt (%{smart_count} Bestellung/en), die alle bestätigten, noch nicht fakturierten Positionen umfasst. Vollständig fakturierte oder unbestätigte Bestellungen werden übersprungen.",
        bulk_order_invoice_nothing_selected: "Mindestens eine Bestellung auswählen.",
        bulk_create_item_invoice_explanation:
          "Die ausgewählten Positionen werden zu einer Rechnung je Bestellung zusammengefasst (%{smart_count} Bestellung(en)). Stornierte oder bereits abgerechnete Positionen werden übersprungen.",
        bulk_item_invoice_nothing_selected: "Mindestens eine Position auswählen.",
        bulk_invoice_overrides:
          "Optionale Überschreibungen für alle erstellten Rechnungen. Leer lassen, dann behält jede Rechnung ihre eigene ermittelte Vorlage, ihren Titel und Leistungszeitraum.",
        bulk_invoice_default_placeholder: "Standard pro Auftrag",
        bulk_invoice_bookings_without_order:
          "%{smart_count} ausgewählte Buchung(en) sind keiner Bestellung zugeordnet und können nicht fakturiert werden.",
        bulk_invoice_nothing_selected: "Keine der ausgewählten Buchungen kann fakturiert werden.",
        bulk_invoice_missing_addresses:
          "Eine Bestellung hat keine verwendbare Rechnungsadresse und wird übersprungen: %{orders} |||| %{smart_count} Bestellungen haben keine verwendbare Rechnungsadresse und werden übersprungen: %{orders}",
        bulk_invoices_created: "%{smart_count} Rechnung erstellt |||| %{smart_count} Rechnungen erstellt",
        bulk_invoices_skipped: "%{smart_count} Position(en) wurden übersprungen.",
        create_custom_invoice_explanation:
          "Alle Positionen sind bereits fakturiert. Zeilen hinzufügen, um eine individuelle Rechnung zu schreiben.",
        invoice_recipient_without_address:
          "%{name} hat keine verwendbare Rechnungsadresse (Straße, PLZ und Ort). Rechnungsinformationen vervollständigen, sonst kann keine Rechnung erstellt werden.",
        invoice_nothing_selected: "Mindestens eine Position zur Fakturierung benötigt.",
        partially_processed: "%{count} Positionen wurden gebucht. Die übrigen sind unten aufgeführt.",
        process_order_explanation:
          "Erstellt eine Buchung für alle offenen, zugewiesenen Positionen (%{count}) dieser Bestellung. Positionen ohne Person werden übersprungen.",
        override_validation: "Verfügbarkeitsprüfungen (u. a. Kapazität) überspringen und Überbuchung zulassen.",
        override_validation_create:
          "Prüfungen (Kapazität, Anmeldefrist) beim Erstellen überspringen, um zu überbuchen.",
        override_validation_shortcut:
          "Kurzbefehl: Shift beim Klick auf den Button halten, um die Auswahl zu aktivieren.",
        change_buyer:
          "Bestellende Person kann nur geändert werden, solange keine Rechnung existiert. Teilnehmende der Positionen werden nicht automatisch geändert.",
        cancel_explanation: "Die gesamte Bestellung wird storniert. Zugehörige Buchungen werden ebenfalls storniert.",
        bulk_cancel_explanation:
          "%{smart_count} Bestellung(en) werden mit allen Positionen und Buchungen storniert. Bereits stornierte Bestellungen werden übersprungen.",
        bulk_canceled: "Bestellungen storniert",
        bulk_cancel_skipped_entry: "#%{id}: %{reason}",
        bulk_cancel_nothing_open: "Nichts mehr zu stornieren - die Auswahl ist bereits storniert.",
        bulk_cancel_no_credit_notes:
          "Es wurde keine Korrektur- oder Stornorechnung erstellt - die zugrundeliegenden Rechnungen sind bereits korrigiert oder storniert.",
        reversal_invoice_rest:
          "Bereits teilweise korrigierte Rechnungen erhalten eine Korrekturrechnung über den Rest.",
        cancel_event_started: "Bereits begonnene Veranstaltung(en):",
        cancel_event_finished: "Bereits beendete Veranstaltung(en):",
        cancel_event_elearning:
          "E-Learning ohne festes Datum. Es könnte bereits begonnen haben bzw. der Zugang wurde möglicherweise schon erteilt:",
        no_invoices: "Es sind keine Rechnungen vorhanden.",
        attendees: "Pro ausgewählter Person wird eine Bestellposition angelegt.",
      },
      labels: {
        no_orders: "Sie haben noch keine Bestellungen.",
        item_count: "%{smart_count} Position |||| %{smart_count} Positionen",
        seat_count: "%{smart_count} Platz |||| %{smart_count} Plätze",
        more_events: "+ %{smart_count} weitere Veranstaltung |||| + %{smart_count} weitere Veranstaltungen",
        self_buyer: "Sie selbst",
        document: "Dokument",
      },
    },
    order_items: {
      name: "Bestellposition |||| Bestellpositionen",
      processing_queue: "Zu bearbeiten",
      labels: {
        no_items: "Diese Bestellung hat keine Positionen.",
      },
      filters: {
        processing_queue: "Ansicht",
        queue_open: "Offene Positionen",
        queue_open_and_requests: "Offene Positionen und Stornoanfragen",
        queue_processed: "Bearbeitete Positionen",
        cancellation_requested: "Stornierung angefragt",
      },
      fields: {
        id: "ID",
        approval_url: "Freigabe-Link",
        is_third_party: "Für andere Person gebucht",
        price_type_name: "Preistyp",
        approval_emails: "E-Mails der Freigebenden",
        state: "Status",
        user: "Teilnehmer*in",
        event: "Veranstaltung",
        price: "Preis",
        offered_price: "Preis",
        adjust_price: "Preis anpassen",
        invoiced_amount: "Abgerechnet",
        attendees: "Teilnehmer*innen",
        format: "Format",
        approval_status: "Freigabe",
        approval_reason: "Begründung",
        cancellation_reason: "Grund der Stornierung (optional)",
        canceled_at: "Storniert am",
        created_at: "Erstellt am",
        price_amount: "Preis",
        notice: "Hinweis",
      },
      state: {
        open: "Offen",
        booked: "Gebucht",
        denied: "Abgelehnt",
        canceled: "Storniert",
      },
      approval: {
        pending: "Freigabe ausstehend",
        approved: "Freigegeben",
        denied: "Abgelehnt",
      },
      actions: {
        cancel_emptied_orders: "Bestellung stornieren |||| Bestellungen stornieren (%{smart_count})",
        use_different_person: "Andere Person als Teilnehmer*in",
        use_buyer_as_attendee: "Käufer*in als Teilnehmer*in",
        adjust_price: "Preis anpassen",
        use_offer_price: "Angebotspreis verwenden",
        add: "Position hinzufügen",
        add_and_book: "Direkt einbuchen",
        edit: "Position bearbeiten",
        edit_person_data: "Personendaten bearbeiten",
        edit_main_contact_info: "Kontaktdaten bearbeiten",
        edit_invoice_contact_info: "Rechnungsadresse bearbeiten",
        edit_invoice_dispatch_contact_info: "Abweichende Rechnungsadresse bearbeiten",
        use_from_source: "Aus Bestellung übernehmen",
        use_custom_fields_and_confirm: "Felder übernehmen & verwenden",
        request_approval: "Freigabe anfordern",
        process: "Verarbeiten",
        create_booking: "Einbuchen",
        create_waiting_list_booking: "Auf Warteliste buchen",
        use_person: "Person verwenden",
        linked: "Verknüpft",
        assign: "Teilnehmer*in zuweisen",
        reassign: "Teilnehmer*in neu zuweisen",
        cancel: "Stornieren",
        request_cancellation: "Stornierung anfragen",
        request_cancellation_confirm:
          "Soll für diese Position eine Stornierung angefragt werden? Die Anfrage wird geprüft, die Stornierung erfolgt nicht automatisch.",
        request_cancellation_confirm_button: "Stornierung anfragen",
        request_cancellation_success: "Stornierungsanfrage wurde erfolgreich versendet.",
        request_cancellation_error: "Stornierungsanfrage fehlgeschlagen. Bitte erneut versuchen.",
        cancellation_requested: "Stornierung angefragt",
        delete: "Position löschen",
        open_processing: "Bearbeiten",
        quick_process: "Schnell buchen",
        previous_item: "Vorherige Position",
        next_item: "Nächste Position",
      },
      headlines: {
        custom_fields: "Angaben zur Buchung",
        lists: "Listen",
        consents: "Einwilligungen",
        buyer: "Bestellende Person",
        buyer_and_attendee: "Person",
        person_fields: "Angaben zur Person",
        matching_persons: "Bestehende Personen",
        processing: "Bestellposition bearbeiten",
        attendee: "Teilnehmer*in",
        purchase: "Gebuchtes Angebot",
        other_items: "Weitere Positionen der Bestellung",
        person: "Personen",
      },
      hints: {
        added: "Position hinzugefügt",
        previous_value: "bisher: %{value}",
        add_blocked_canceled: "Eine stornierte Bestellung kann nicht mehr erweitert werden.",
        add_blocked_prepaid:
          "Eine vorausbezahlte Bestellung kann nicht erweitert werden. Für die zusätzliche Position eine eigene Bestellung anlegen.",
        price_locked_prepaid:
          "Diese Bestellung ist vorausbezahlt. Der Preis kann nicht mehr geändert werden - die Bezahlseite berechnet den Betrag, mit dem die Bestellung angelegt wurde. Stattdessen eine eigene Bestellung anlegen.",
        cancel_prepaid:
          "Diese Bestellung ist vorausbezahlt. Eine Stornierung ändert nichts an dem Betrag, den die Bezahlseite berechnet oder bereits berechnet hat - die Zahlung anschließend manuell abgleichen.",
        items_in_orders:
          "Die %{items} Bestellpositionen gehören zu %{smart_count} Bestellung. |||| Die %{items} Bestellpositionen gehören zu %{smart_count} Bestellungen.",
        orders_keep_items:
          "%{smart_count} davon hat weitere aktive Positionen und bleibt bestehen. |||| %{smart_count} davon haben weitere aktive Positionen und bleiben bestehen.",
        remaining_orders_emptied:
          "Die übrige Bestellung hätte sonst keine aktive Position mehr. |||| Die übrigen %{smart_count} hätten sonst keine aktive Position mehr.",
        all_orders_keep_items:
          "Die Bestellung hat weitere aktive Positionen und bleibt bestehen. |||| Die Bestellungen haben weitere aktive Positionen und bleiben bestehen.",
        cancel_emptied_orders:
          "Die Bestellung hätte sonst keine aktive Position mehr. |||| Diese Bestellungen hätten sonst keine aktive Position mehr.",
        credit_note_mixed:
          "Stornierte Bestellungen erhalten eine Stornorechnung, bereits teilweise korrigierte Rechnungen eine Korrekturrechnung über den Rest. Bei den übrigen Bestellungen wird eine Korrekturrechnung über die stornierten Positionen erstellt.",
        add_to_confirmed_order:
          "Diese Bestellung ist bereits bestätigt. Die neue Position wird nicht automatisch berechnet - die Rechnung bleibt ein eigener Schritt.",
        book_requires_confirmed_order: "Einbuchen ist erst möglich, wenn die Bestellung bestätigt ist.",
        edit_invoiced_item:
          "Diese Position ist bereits berechnet. Preisänderungen werden nicht automatisch nachberechnet oder korrigiert - dafür muss eine weitere Rechnung bzw. eine Korrekturrechnung erstellt werden.",
        thank_you_headline: "Vielen Dank! Die Daten wurden erfolgreich übermittelt.",
        approval: "Freigeben",
        mismatch_in_person_data:
          "Die erfassten Daten weichen von den Daten dieser Person ab. Erfasste Werte übernehmen oder bestehende behalten?",
        request_approval_explanation:
          "Sendet die Freigabeanfrage an die angegebenen Adressen. Jede Person erhält einen signierten Link zum Freigeben oder Ablehnen.",
        approval_requested: "Freigabeanfrage gesendet",
        approval_emails: "Mehrere Adressen mit Komma trennen.",
        open_items_count: "%{count} offene Position |||| %{count} offene Positionen",
        processed_items_count: "%{count} bearbeitete Position |||| %{count} bearbeitete Positionen",
        no_processable_items: "Keine zu bearbeitenden Positionen.",
        no_processed_items: "Keine bearbeiteten Positionen.",
        unassigned: "Nicht zugewiesen",
        processing_hints: "%{smart_count} Hinweis vor dem Einbuchen |||| %{smart_count} Hinweise vor dem Einbuchen",
        event_fully_booked_short: "Die Veranstaltung ist bereits ausgebucht.",
        child_fully_booked_short: "Die Unterveranstaltung %{names} ist bereits ausgebucht.",
        approval_denied_short: "Die Freigabe für diese Position wurde abgelehnt",
        similar_booking_short: "Möglicherweise eine Doppelbuchung. Es gibt bereits eine ähnliche Buchung:",
        cancellation_requested_short: "Für diese Position wurde eine Stornierung angefragt",
        bulk_cancel_explanation:
          "%{smart_count} Position(en) werden mit ihren Buchungen storniert. Die übrigen Positionen ihrer Bestellungen bleiben unberührt.",
        bulk_canceled: "Positionen storniert",
        processed: "Position gebucht",
        assigned: "Person zugewiesen",
        canceled: "Position storniert",
        deleted: "Position gelöscht",
        delete_explanation:
          "Die Position wird endgültig gelöscht, als hätte sie nie existiert. Eine tatsächlich stattgefundene Bestellung sollte stattdessen storniert werden.",
        delete_blocked:
          "Diese Position kann nicht gelöscht werden: Sie ist gebucht oder fakturiert, oder sie ist die letzte Position der Bestellung (dann die Bestellung löschen).",
        cancel_explanation: "Diese Position wird storniert. Zugehörige Buchungen werden ebenfalls storniert.",
        process_explanation: "Buchung für %{name} in %{event} erstellen.",
        quick_process:
          "Schnelles Buchen für bereits zugewiesene Positionen. Für Dublettenabgleich oder Zuweisung die Bearbeitungsseite öffnen.",
        matching_persons:
          "Bestehende Personen mit übereinstimmendem Namen oder E-Mail. Verknüpfen, um Dubletten zu vermeiden.",
        no_matching_persons: "Keine übereinstimmenden Personen gefunden.",
        person_used: "Wird verwendet",
        approval_for: "Freigabe der Anmeldung",
      },
    },
    emails: {
      name: "E-Mail |||| E-Mails",
      single_emails: "Einzelne E-Mails",
      is_archived: "Diese E-Mail ist archiviert",
      fields: {
        subject: "Betreff",
        template: "Vorlage",
        created_at: "Erstellt am",
        status: "Status",
        to: "An",
        bounce_reason: "Ablehnungsgrund",
        scheduled_at: "Versanddatum",
      },
      status: {
        waiting_for_transfer: "Warte auf Übertragung",
        transfered: "Übertragen",
        sent: "Versendet",
        blocked: "Blockiert",
        error: "Fehler beim Versand",
      },
      actions: {
        resend: "Erneut senden",
      },
      hints: {
        undeliverableEmails: "Eine E-Mail wird nicht zugestellt |||| %{smart_count} E-Mails werden nicht zugestellt",
        duplicateRecipients:
          "Eine Adresse erhält mehrere E-Mails |||| %{smart_count} Adressen erhalten mehrere E-Mails",
        noEmailAddress: "Keine E-Mail-Adresse",
        noListConsentGiven: "Keine Einwilligungserklärung für die Liste",
      },
    },
    email_jobs: {
      name: "E-Mail-Versand |||| E-Mail-Versand",
      is_archived: "Dieser E-Mail-Versand ist archiviert",
      fields: {
        created_at: "Erstellt am",
        sender: "Absendeadresse",
        body: "Inhalt",
        emails: "An",
        attachments: "Anhänge",
        recipients: "Empfänger",
        template: "Vorlage",
        created_by: "Erstellt von",
        custom_to: "E-Mail-Adresse",
      },
      actions: {
        group_by_jobs: "Nach Versand gruppieren",
      },
    },
    email_senders: {
      name: "E-Mail Absender",
      fields: {
        name: "Name",
        email: "E-Mail",
        signature: "Signatur",
        users: "Berechtigte Mitarbeitende",
        lecturers: "Berechtigte Dozierende",
        external_id: "Externe ID",
        use_for_reply: "Als Antwort-Adresse verwenden",
      },
    },
    event_lecturers: {
      name: "Dozent*in |||| Dozierende",
    },
    events: {
      name: "Veranstaltung |||| Veranstaltungen",
      name_singular: "Veranstaltung",
      is_archived: "Diese Veranstaltung ist archiviert",
      invalid_archive_filter: 'Der Archiviert-Filter ist auf "Alle" gesetzt. Archivieren nicht möglich.',
      array_input_fields: {
        dates: "Termine",
        group_children: "Veranstaltung |||| Veranstaltungen",
        group_parents: "Veranstaltungsgruppe |||| Veranstaltungsgruppen",
        prices: "Preis |||| Preise",
        lecturers: "Dozent*in |||| Dozierende",
      },
      bulk_update_dates: {
        has_day: "Tag ändern",
        has_time: "Uhrzeit ändern",
        has_format: "Format ändern",
        has_location: "Ort ändern",
      },
      fields: {
        id: "ID",
        attendees_max: "Teilnehmende max.",
        attendees_min: "Teilnehmende min.",
        capacity: "Kapazität",
        child_event_base: "Angebot",
        cost_center: "Kostenstelle",
        cost_object: "Kostenträger",
        project_number: "Projektnummer",
        created_at: "Erstellt",
        event_base: "Angebot",
        event_base_group_parent: "Angebotsgruppe",
        group_parent: "Veranstaltungsgruppe",
        group_child: "Veranstaltung",
        external_url: "Öffentliche URL",
        first_day: "Termin",
        last_day: "Letzter Veranstaltungstag",
        first_day_end_time: "Termin Ende",
        first_day_start_time: "Termin Start",
        id_number: "Nummer",
        inventory_account: "Sachkonto",
        is_bookable: "Buchbar",
        format: "Format",
        is_solo_bookable: "Einzeln buchbar",
        lecturers: "Dozierende",
        location: "Veranstaltungsort",
        meta: {
          event_base_category_names: "Kategorien",
          event_base_name: "Angebotstitel",
          event_base_type_name: "Angebotstyp",
          all_valid_bookings_count: "Teilnahmezahlen",
        },
        online_invite_text: "Meeting-Informationen",
        prices: "Preise",
        registration_begin: "Anmeldezeitraum: Beginn",
        registration_deadline: "Anmeldezeitraum: Ende",
        remaining_dates: "Weitere Termine",
        responsibilities: "Zuständigkeiten",
        responsible_persons: "Zuständige Personen",
        is_public: "Öffentlich",
        is_child: "Veranstaltung in einer Gruppe",
        is_parent: "Veranstaltungsgruppe",
        rooms: "Räume",
        status: "Status",
        lecturers_may_edit_attendance: "Dozierende dürfen Teilnahme bearbeiten",
        display_in_portal: "Im Portal sichtbar",
        is_billable: "Abrechenbar",
        bookings: "Buchungen",
        event_location_name: "Name des Veranstaltungsorts",
        event_lecturer_names: "Namen der Dozenten",
        all_valid_bookings_count: "Anzahl der gültigen Buchungen",
        all_waiting_bookings_count: "Anzahl der wartenden Buchungen",
        dates_count: "Anzahl Termine",
        dates: "Termine",
        event_base__name: "Angebotstitel",
        event_base__event_type__name: "Angebotstyp",
        location__name: "Veranstaltungsort",
      },
      actions: {
        new_event: "Neu anlegen",
        existing_event: "Daten übernehmen",
        create_event: "Veranstaltung erstellen",
        change_status: "Status ändern",
        bulk_update: "Stammdaten ändern",
        change_format: "Format ändern",
        change_event_base: "Angebot ändern",
        create_booking: "Buchung hinzufügen",
        create_bookings: "Buchungen hinzufügen",
        select_persons: "Personen auswählen",
        select_event: "Veranstaltung auswählen",
        create_interest: "Interessent*in hinzufügen",
        create_group: "Gruppieren",
        add_moodle_course: "Moodle-Kurs verknüpfen",
        remove_moodle_course: "Moodle-Kurs-Verknüpfung entfernen",
        show_event_base: "Zum Angebot",
        add_to_event_group: "Zu Gruppe hinzufügen",
        add_child_event_to_group: "Veranstaltung hinzufügen",
        duplicate: "Duplizieren",
        add_lecturer: "Dozent*in hinzufügen",
        add_new_lecturer: "Dozent*in erstellen und zuweisen",
        connect_existing_lecturer: "Dozent*in zuweisen",
        edit_accounting_fields: "Buchhaltungsfelder bearbeiten",
        edit_responsibilities: "Zuständigkeiten für „%{responsibilityType}“ bearbeiten",
        update_children_status: "Status aller untergeordneten Veranstaltungen ebenfalls aktualisieren",
        add_feedback_form: "Feedbackbogen hinzufügen",
        update_dates: "Termine bearbeiten",
      },
      validation: {
        number_not_unique: "Die Veranstaltungsnummer wird bereits verwendet",
      },
      headlines: {
        cancel_order_items: "Bestellpositionen stornieren",
      },
      hints: {
        cancel_order_items_explanation:
          "Die Veranstaltung ist storniert. %{smart_count} Position(en) bestätigter Bestellungen sind noch dafür gebucht. Diese mit ihren Buchungen stornieren? Positionen anderer Veranstaltungen derselben Bestellung bleiben unberührt.",
      },
    },
    event_bases: {
      name: "Angebot |||| Angebote",
      name_singular: "Angebot",
      is_archived: "Dieses Angebot ist archiviert",
      fields: {
        image_path: "Bildpfad",
        name: "Name",
        slug: "URL Segment",
        summary: "Zusammenfassung",
        event_type: "Typ",
        event_type_name: "Name des Eventtyps",
        contact_persons: "Kontaktpersonen",
        group_parent: "Angebotsgruppe",
        partners: "Kooperationspartner",
        tags: "Schlagworte",
        contexts: "Umgebungen",
        categories: "Kategorien",
        audiences: "Zielgruppen",
        descriptions: "Beschreibungen",
        image: "Bild",
        documents: "Dokumente",
        created_at: "Erstellt",
        updated_at: "Aktualisiert",
        external_url: "Öffentliche URL",
        event_count: "Anzahl Veranstaltungen",
        event_type__name: "Typ",
      },
      actions: {
        duplicate: "Duplizieren",
        new_event_base: "Neues Angebot",
        existing_event_base: "Bestehendes Angebot",
        change_event_type: "Angebotstyp ändern",
        create_event: "Veranstaltung hinzufügen",
        create_event_base: "Angebot erstellen",
        create_event_base_child: "Unterangebot erstellen",
        create_event_group: "Veranstaltungsgruppe erstellen",
        show_event_base_group: "Zur Angebotsgruppe",
        add_description_field: "Feld hinzufügen",
        show_old_descriptions: "Alte Beschreibungen anzeigen",
        hide_old_descriptions: "Alte Beschreibungen ausblenden",
      },
    },
    event_base_descriptions: {
      name: "Angebotsbeschreibung |||| Angebotsbeschreibungen",
      fields: {
        description_type: "Beschreibungstyp",
        text: "Text",
      },
    },
    event_base_description_fields: {
      name: "Beschreibungsfeld |||| Beschreibungsfelder",
      fields: {
        label: "Label",
        slug: "Identifikator",
        field_type: "Feldtyp",
        width: "Breite",
        show_per_default: "Immer anzeigen",
        soft_required: "Erforderlich",
      },
    },
    event_dates: {
      name: "Termin |||| Termine",
      fields: {
        has_attended: "Teilgenommen",
        id: "ID",
        event: "Veranstaltung",
        day: "Tag",
        different_location: "Abweichender Ort",
        start_time: "Beginn (Uhrzeit)",
        end_time: "Ende (Uhrzeit)",
        start_datetime: "Beginn",
        end_datetime: "Ende",
        location: "Ort",
        format: "Format",
      },
      headlines: {
        date: "Termin",
        date_details: "Termindetails",
      },
      formats: {},
    },
    event_feedback_forms: {
      name: "Veranstaltungsfeedbackbogen |||| Veranstaltungsfeedbackbögen",
      fields: {
        event: "Veranstaltung",
        valid_until: "Gültig bis",
        feedback_form: "Feedbackbogen",
        url: "Formular-URL",
        name: "Formular-Name",
        reporting_visible_for_lecturers: "Auswertung für Dozierende einsehbar",
      },
      actions: {
        download_qr_code: "QR-Code herunterladen",
        remove_from_event: "Von Veranstaltung entfernen",
        edit: "Feedbackbogen bearbeiten",
      },
      labels: {
        additional_text: "Erläuterung",
        add_text_response: "Textantwort hinzufügen",
      },
    },
    event_locations: {
      name: "Veranstaltungsort |||| Veranstaltungsorte",
      fields: {
        image_path: "Bildpfad",
        name: "Name",
        email: "E-Mail",
        rooms: "Räume",
        url: "URL",
        lat: "Breitengrad",
        lon: "Längengrad",
        info: "Information",
        address: userFields.contact_info,
      },
    },
    event_moodle_courses: {
      name: "Moodle-Kurs Verknüpfung |||| Moodle-Kurs Verknüpfungen",
      actions: {
        disconnect_moodle_course: "Moodle-Kurs-Verknüpfung trennen",
      },
    },
    event_rooms: {
      name: "Veranstaltungsraum |||| Veranstaltungsräume",
      fields: {
        identifier: "Raumkennung",
        location_name: "Veranstaltungsort",
      },
    },
    event_types: {
      name: "Angebotstyp |||| Angebotstypen",
      template_hint:
        "Diese Vorlagen gelten für Bestellungen und Buchungen dieses Angebotstyps. Eine Bestellung mit mehreren Angebotstypen verwendet die Standardvorlage des Systems.",
      array_input_fields: {
        description_fields: "Beschreibungsfeld |||| Beschreibungsfelder",
      },
      fields: {
        name: "Name",
        invoice_template: "Rechnungs Vorlage",
        invoice_mail_template: "Rechnungs-E-Mail Vorlage",
        booking_confirmation_template: "Buchungsbestätigungs-E-Mail Vorlage",
        order_manual_processing: "Bestellbearbeitung",
      },
      order_manual_processing_hint:
        "Bestellungen mit manuellen und automatischen Positionen werden immer manuell bearbeitet.",
      order_manual_processing_choices: {
        inherit: "Allgemeine Einstellung verwenden (%{value})",
        manual: "Manuell",
        auto: "Automatisch",
      },
      headlines: {
        settings: "Anzeige-Einstellungen",
        templates: "Vorlagen",
      },
    },
    external_email_templates: {
      name: "E-Mail Vorlage |||| E-Mail Vorlagen",
      fields: {
        scope: "Bereich",
        external_id: "Externe ID",
        subject: "Betreff",
        sender: "Standard-Absender",
        is_default: "Standard-Vorlage",
        bcc: "BCC E-Mail-Adresse",
        language: "Sprache",
        parent_template: "Übergeordnete Vorlage",
        recipient_role: "Standard-Empfänger",
        recipient_contact_info_type: "Standard-Adresstyp",
      },
      helper_texts: {
        recipient_role: "Hat die Bestellung keine Organisation, erhält die bestellende Person die E-Mail.",
      },
      array_input_fields: {
        content_blocks: "Inhaltsblöcke",
        event_blocks: "Veranstaltungsblöcke",
      },
      headlines: {
        scope_info: "Beschreibung der Bereiche",
      },
    },
    feedback_forms: {
      name: "Feedbackbogen |||| Feedbackbögen",
      fields: {
        name: "Name",
        introduction: "Einleitung",
        closing_remark: "Abschlusstext",
        questions: "Fragen",
      },
      array_input_fields: {
        questions: "Fragen",
      },
      actions: {
        add_question: "Frage hinzufügen",
        add_as_new_question: "Als neue Frage hinzufügen",
        send: "Feedback senden",
        group_questions: "Nach Fragen gruppieren",
        add_question_group: "Fragengruppe hinzufügen",
        add_question_group_template: "Fragengruppe-Vorlage verwenden",
        new_question: "Neue Frage",
        existing_question: "Bestehende Frage",
        duplicate: "Duplizieren",
      },
    },
    feedback_form_question_groups: {
      name: "Fragengruppe |||| Fragengruppen",
      fields: {
        name: "Name",
        description: "Beschreibung",
      },
      template: "Fragengruppen",
      hints: {
        load_from_template:
          "Die ausgewählte Fragengruppe inklusive der Fragen wird dem Feedbackbogen unten hinzugefügt. Falls die Fragen bereits im Feedbackbogen vorhanden sind, werden sie ignoriert und nicht übernommen.",
      },
    },
    question_select_values: {
      name: "Auswahlmöglichkeit |||| Auswahlmöglichkeiten",
      fields: {
        value: "Wert",
      },
    },
    files: {
      name: "Dokument |||| Dokumente",
      fields: {
        file_size: "Dateigröße",
        variant_urls: "URLs der Bildvarianten",
        id: "ID",
        data: "Daten",
        related_id: "Verknüpfte ID",
        related_resource: "Verknüpfte Resource",
        mime_types: "MIME Types",
        created_by: "Erstellt von",
        created_at: "Erstellt am",
        url: "URL",
        description: "Beschreibung",
        name: "Name",
        name_sortable: "Name",
        original_filename: "Dateiname",
        tags: "Schlagworte",
        visible_for_all: "Öffentlich",
        visible_for_attendees: "Für Teilnehmende im Portal freigegeben",
        visible_for_lecturers: "Für Dozierende im Portal freigegeben",
        visibility: "Freigaben",
      },
      actions: {
        open: "Datei öffnen",
      },
      hints: {
        file_not_previewable: "Für dieses Dateiformat ist keine Vorschau möglich.",
      },
    },
    generated_documents: {
      name: "Automatisch erstelltes Dokument |||| Automatisch erstellte Dokumente",
      hints: {
        persist_on_relation:
          "Das Dokument wird am aktuellen Datensatz (%{relationName}) hinterlegt und ist für Mitarbeitende sichtbar. Es können zusätzliche Freigaben vergeben werden: |||| Die Dokumente werden an den %{relationName} hinterlegt und sind für Mitarbeitende sichtbar. Es können weitere Freigaben vergeben werden: ",
      },
    },
    generate_document_tasks: {
      name: "Dokumentenerstellungs-Auftrag |||| Dokumentenerstellungs-Aufträge",
    },
    integrated_applications: {
      name: "Verknüpfte Applikation |||| Verknüpfte Applikationen",
      fields: {
        active: "Aktiv",
        name: "Name",
      },
      labels: {
        activate: "Aktivieren",
        deactivate: "Deaktivieren",
        inactive: "Inaktiv",
        active: "Aktiv",
        connect: "Verknüpfen",
        disconnect: "Trennen",
        finish_oauth_connect: "OAuth-Verknüpfung abschließen",
      },
    },
    interests: {
      name: "Interessent*in |||| Interessierte",
      fields: {
        person: "Person",
        event_base_or_event: "Angebot / Veranstaltung",
        event_name: "Veranstaltung",
        user_full_name: "Name",
        created_at: "Erstellt",
        user__last_name: "Nachname",
        note: "Notiz",
      },
      actions: {
        remove: "Favorit entfernen",
        edit: "Interesse bearbeiten",
      },
    },
    invoices: {
      name: "Rechnung |||| Rechnungen",
      headlines: {
        covered_items: "Fakturierte Positionen",
        related: "Zugehörige Rechnungen",
        covered_line_items: "Bereits fakturierte und kostenlose Positionen (%{count})",
        preview: "Vorschau",
        details: "Details",
      },
      fields: {
        title: "Titel",
        first_name: "Vorname",
        last_name: "Nachname",
        organization_name: "Organisationsname",
        is_organization: "Ist Organisation",
        debit_number: "Debitorennummer",
        parent: "Ursprungsrechnung",
        sum_without_tax: "Summe netto",
        kind: "Typ",
        template: "Rechnungsvorlage",
        override_contact_info: "Rechnungsadresse überschreiben",
        price: "Preis",
        name: "Titel",
        download: "Download",
        invoice_number: "Rechnungsnummer",
        service_period: "Leistungszeitraum",
        generated_at: "Generiert",
        created_at: "Rechnungsdatum",
        due_date: "Fälligkeitsdatum",
        sent_at: "Versendet",
        recipient: "Rechnungsempfänger*in",
        payment: "Zahlung",
        accounting_transfer_success_at: "Übertragen",
        accounting_transfer_error: "Übertragungsfehler",
        is_paid: "Bezahlt",
        price_gross: "Brutto",
        price_net: "Netto",
        credited: "abzüglich Korrektur- und Stornorechnungen",
        effective: "Effektiv",
        booking__event__event_base__name: "Angebotstitel",
        booking__attendee__last_name: "Nachname",
        buyer_name: "Bestellt von",
        order__order_number: "Bestellnummer",
        paid_amount: "Bezahlter Betrag",
        external_accounting_id: "Buchhaltungs-ID",
        recipient_name: "Empfängername",
        reference: "Referenz",
        referenced_by: "Referenziert von",
      },
      actions: {
        show_booking: "Zur Buchung",
        show_order: "Zur Bestellung",
        download: "Rechnung herunterladen",
        set_is_paid: "Als bezahlt markieren",
        unset_is_paid: "Als unbezahlt markieren",
        bulk_reversal: "Rechnungen stornieren",
        reverse: "Stornieren",
        correct: "Korrigieren",
        add_line_item: "Position hinzufügen",
        drop_line_item: "Entfernen",
        open_in_external_accounting: "In Buchhaltung öffnen",
        sync_with_external_accounting: "Mit Buchhaltung synchronisieren",
        reset_accounting_transfer: "Übertragung zurücksetzen",
      },
      kinds: {
        standard: "Standard",
        correction: "Korrekturrechnung",
        reversal: "Stornorechnung",
      },
      hints: {
        unresolved_accounting_lines_title: "Fehlende Buchhaltungsfelder",
        unresolved_accounting_lines_hint: "Für diese Veranstaltungen sind noch keine Buchhaltungsfelder gepflegt:",
        accounting_transfer_error_hint: "Bei der Übertragung ist ein Fehler aufgetreten:",
        due_on: "Fällig am %{date}",
        pdf_not_generated: "Das Rechnungsdokument wurde noch nicht erzeugt.",
        reference: "Rechnung, auf die sich das Dokument bezieht.",
        reverse_explanation:
          "Die gesamte Rechnung wird mit einer Stornorechnung storniert. Das kann nicht rückgängig gemacht werden.",
        correct_explanation: "Diese Positionen werden als Korrekturrechnung erstellt.",
        reversal_created: "Stornorechnung erstellt",
        document_generation_failed: "Das Dokument konnte nicht generiert werden. Rechnungsvorlage prüfen.",
        correction_created: "Korrekturrechnung erstellt",
        reversal_partially_skipped:
          "Stornorechnung erstellt; %{count} Rechnung(en) wurden übersprungen, da sie nicht storniert werden konnten.",
        accounting_transfer_started: "Übertragung zur Buchhaltung gestartet",
        reset_accounting_transfer_success: "Zurücksetzen der Übertragung erfolgreich",
        reset_accounting_transfer_error: "Fehler beim Zurücksetzen der Übertragung",
        reset_accounting_transfer_hint:
          "Soll die Übertragung wirklich zurückgenommen werden? Dadurch gehen die Buchhaltungs-Daten verloren und eine erneute Übertragung kann gestartet werden.",
        no_invoice_templates_present:
          "Vor dem Erstellen einer Rechnung muss eine Rechnungsvorlage (%{kind}) hinterlegt werden.",
        line_item_already_invoiced:
          "Diese Position ist bereits fakturiert. Hier nur erfassen, was zusätzlich berechnet wird.",
        line_item_free:
          "Kostenlose Position - nichts zu fakturieren. Hier nur erfassen, was zusätzlich berechnet wird.",
        line_item_not_billed: "Nicht fakturiert",
        discarded_after_document_failure:
          "Die Rechnung wurde verworfen, weil kein Dokument erzeugt werden konnte. |||| Die Rechnungen wurden verworfen, weil keine Dokumente erzeugt werden konnten.",
        credit_amount_negative: "Der Korrekturbetrag muss negativ sein.",
        credit_amount_positive: "Die Korrektur einer Rabattzeile ist ein positiver Betrag.",
        correction_nothing_selected: "Mindestens eine Rechnungszeile muss Korrekturzeilen behalten.",
        bulk_reversal_placeholder:
          "Der Platzhalter %{invoiceNumber} wird beim Generieren der Rechnung durch die jeweilige ursprüngliche Rechnungsnummer ersetzt.",
      },
    },
    invoice_tax_amounts: {
      name: "Steuerbetrag je Steuersatz |||| Steuerbeträge je Steuersatz",
      fields: {
        tax_rate: "Steuersatz",
        amount: "Steuerbetrag",
      },
    },
    invoice_templates: {
      name: "Rechnungsvorlage |||| Rechnungsvorlagen",
      fields: {
        name: "Name",
        zugferd_tax_exemption_reason_text: "Steuerbefreiungsgrund",
        zugferd_payment_terms_description: "Zahlungsbedingungen",
        zugferd_payment_means_code_type: "Zahlungsmittel-Code",
        is_default: "Standard-Vorlage",
      },
      hints: {
        zugferd_fields: "ZUGFeRD Felder",
      },
    },
    lecturers: {
      name: "Dozent*in |||| Dozierende",
      fields: userFields,
      is_archived: "Diese*r Dozent*in ist archiviert",
      actions: {
        enroll_to_moodle_courses: "Dozent*in in Moodle-Kurs einbuchen",
      },
    },
    notes: {
      name: "Notiz |||| Notizen",
      fields: {
        high_priority: "Angeheftet",
        text: "Text",
      },
      actions: {
        pin: "Anheften",
        unpin: "Loslösen",
        delete: "Entfernen",
        create: "Notiz anlegen",
        update: "Notiz aktualisieren",
      },
    },
    contact_infos: {
      name: "Kontaktinformation |||| Kontaktinformationen",
      fields: userFields.contact_info,
    },
    moodle_courses: {
      name: "Moodle-Kurs |||| Moodle-Kurse",
      fields: {
        id_number: "Kursnummer",
        name: "Kursname",
        category: "Bereich",
        short_name: "Kurzer Kursname",
        start_date: "Kursbeginn",
        end_date: "Kursende",
      },
      actions: {
        connect: "Mit bestehendem Kurs verknüpfen",
        delete: "Kurs auch bei Moodle löschen",
        create_new: "Neuen Kurs anlegen und verknüpfen",
        enroll_remaining_attendees:
          "%{numberOfAttendees} weitere Person mit Moodle-Account einbuchen |||| %{numberOfAttendees} weitere Personen mit Moodle-Account einbuchen",
        enroll_all_valid_attendees: "Personen mit Moodle-Account in Kurs einbuchen",
      },
      moodle_course_has_no_users_enrolled: "Bisher wurde keine Personen in diesen Kurs eingebucht.",
      moodle_course_number_of_enrolled_bookings: "%{numberEnrollments} von %{numberBookings} Personen eingebucht",
      connected_lecturers: "Verknüpfte Dozierende",
    },
    moodle_enrollments: {
      name: "Moodle-Einbuchung |||| Moodle-Einbuchungen",
      history_change: "für %{userName} im Kurs %{courseName}",
    },
    moodle_users: {
      name: "Moodle-Account |||| Moodle-Accounts",
      is_connected_with_moodle: "Ist verknüpft mit einem",
      actions: {
        delete: "Account auch bei Moodle löschen",
      },
      moodle_number_of_enrollments_info:
        "Es wird %{smart_count} %{resource} in die ausgewählten Moodle-Kurse eingebucht |||| Es werden %{smart_count} %{resource} in die ausgewählten Moodle-Kurse eingebucht",
    },
    o_auth_apps: {
      name: "OAuth Applikation |||| OAuth Applikationen",
      fields: {
        is_superapplication: "Admin App",
        client_type: "Client Type",
        client_id: "Client ID",
        client_secret: "Client Secret",
        authorization_grant_type: "Authorization Grant Type",
        auth_groups: "Berechtigungsgruppen",
        redirect_uris: "Redirect URIs",
        post_logout_redirect_uris: "Post Logout Redirect URIs",
        skip_authorization: "Autorisierung überspringen",
        pkce_required: "PKCE erforderlich",
        algorithm: "Algorithmus",
        application_permissions: "Berechtigungen",
      },
      helper_texts: {
        client_secret_create: "Leer lassen, um automatisch ein Secret zu generieren.",
        client_secret_edit:
          "Aus Sicherheitsgründen nicht angezeigt. Leer lassen, um das aktuelle Secret beizubehalten.",
      },
    },
    occupancy: {
      name: "Auslastung",
      fields: {
        unprocessed_order_items: "unbearbeitete Bestellposition |||| unbearbeitete Bestellpositionen",
        held_order_seats: "reservierter Platz (Bestellung) |||| reservierte Plätze (Bestellungen)",
        attendees_max: "von max. %{max} Teilnehmenden",
        attendees_min_reached: "Mindestanzahl %{min} erreicht",
        attendees_min: "bis zur Mindestanzahl %{min}",
        waiting: "wartend",
        vacant_bookings: "verfügbarer Platz |||| verfügbare Plätze",
        vacant_waiting_hint: "%{count} auf Warteliste",
      },
    },
    organizations: {
      name: "Organisation |||| Organisationen",
      is_archived: "Diese Organisation ist archiviert",
      self_created: "Angelegt von",
      actions: {
        quick_create: "Neue Organisation anlegen",
      },
      fields: {
        id: "ID",
        invoice_contact_info: "Rechnung",
        invoice_dispatch_contact_info: "Rechnungsversand",
        name: "Name",
        tags: "Schlagworte",
        debit_number: "Debitorennummer",
        value_added_tax_id: "USt-IdNr.",
        trade_register_number: "Handelsregisternummer",
        self_created_by: "Extern angelegt von",
        fiscal_number: "Steuernummer",
        created_at: "Erstellt am",
      },
    },
    organization_memberships: {
      name: "Organisationszugehörigkeit |||| Organisationszugehörigkeiten",
    },

    organization_users: {
      name: "Person |||| Personen",
      labels: {
        no_members: "Dieser Organisation sind noch keine Personen zugeordnet.",
      },
      fields: {
        organization: "Organisation",
        user: "Person",
        permissions: "Berechtigungen",
        can_edit_organization: "Organisation bearbeiten",
        can_enroll: "Bestellungen aufgeben",
        can_manage_users: "Personen verwalten",
        create_login: "Portalzugang einrichten",
        created_at: "Erstellt am",
      },
      hints: {
        create_login: "Die Person erhält eine E-Mail zur Einrichtung ihres Zugangs.",
      },
      actions: {
        disconnect: "Verknüpfung entfernen",
        add_member: "Person hinzufügen",
        select_existing_organization: "Bestehende Organisation",
        create_new_organization: "Neue Organisation",
      },
    },
    price_types: {
      name: "Preistyp |||| Preistypen",
      fields: {
        name: "Name",
        short_name: "Abkürzung",
      },
      is_archived: "Dieser Preistyp ist archiviert",
      for_free: "Kostenlos",
    },
    price_positions: {
      name: "Position |||| Positionen",
      default_first_position_name: "Teilnahme",
      fields: {
        sales_tax: "Umsatzsteuer",
        attendee_name: "Teilnehmer*in",
        event_name: "Veranstaltung",
        event_id_number: "Veranstaltungs-Nummer",
        amount: "Betrag",
        name: "Name",
        quantity: "Menge",
        inventory_account: "Sachkonto",
        tax_rate: "MwSt.",
        incl_tax: "inkl. %{amount} MwSt.",
      },
    },
    prices: {
      name: "Preis |||| Preise",
      fields: {
        amount: "Betrag",
        cached_amount: "Betrag",
        positions: "Positionen",
        price_type: "Preistyp",
        price_type_name: "Name des Preistyps",
        valid_from: "Gültig ab",
        valid_until: "Gültig bis",
      },
      labels: {
        amount: "Betrag",
        invoiced_amount: "Abgerechneter Betrag",
        paid_amount: "Bezahlstatus",
        paid: "Bezahlt",
        price_override: "Preis manuell angepasst",
      },
      tooltips: {
        amount:
          "Der zu zahlende Betrag mit seinem Preistyp. Null bedeutet „kostenlos“ - außer wenn der Betrag nur deshalb null ist, weil alle Positionen storniert wurden; dann wird der Betrag selbst angezeigt.",
        invoiced_amount:
          "Sobald ein Teil des Betrags berechnet ist, steht die berechnete Summe davor: grau solange sie unter dem Betrag liegt, orange wenn sie darüber liegt. Ist alles berechnet, wird der Betrag grün.",
        paid_amount:
          "Ein doppelter grüner Haken bedeutet, dass der gesamte Betrag bezahlt ist, ein einfacher Haken, dass alles bisher Berechnete bezahlt ist. Eine Teilzahlung wird als Betrag angezeigt. Kein Zeichen bedeutet, dass noch nichts bezahlt wurde.",
      },
    },
    partners: {
      name: "Kooperationspartner",
      fields: {
        logo_path: "Logopfad",
        id: "ID",
        name: "Name",
        url: "URL",
        logo: "Logo",
      },
    },
    qualifications: {
      name: "Qualifikation |||| Qualifikationen",
    },
    questions: {
      name: "Frage |||| Fragen",
      fields: {
        type: "Fragentyp",
      },
      types: {
        RATING: "Bewertung",
        SINGLE_CHOICE: "Single Choice",
        MULTIPLE_CHOICE: "Multiple Choice",
        FREE_TEXT: "Freitext",
      },
    },
    report: {
      name: "Auswertung",
    },
    response_forms: {
      name: "Feedback-Auswertung",
      filters: {
        feedback_form: "Bogen",
        event: "Veranstaltung",
        lecturers: "Dozierende",
        event_base: "Angebot",
        responsible_person: "Zuständige Person",
        question: "Frage",
        date_to: "Erstellt bis",
        date_from: "Erstellt von",
        question_type: "Frage-Typ",
      },
    },
    responses: {
      name: "Antwort |||| Antworten",
    },
    responsibilities: {
      name: "Zuständigkeit |||| Zuständigkeiten",
    },
    responsibility_types: {
      name: "Zuständigkeitstyp |||| Zuständigkeitstypen",
      fields: {
        event_types: "Angebotstypen",
      },
    },
    settings: {
      name: "Allgemein",
      fields: {
        value: "Wert",
        key: "Einstellung",
      },
    },
    webhook_subscriptions: {
      name: "Webhook Subscription |||| Webhook Subscriptions",
    },
    subscriptions: {
      name: "Webhook |||| Webhooks",
      fields: {
        name: "Name",
        is_active: "Aktiv",
        endpoint_url: "Endpunkt-URL",
        event_types: "Ereignisse",
        secret: "Secret",
      },
      helper_texts: {
        secret_edit: "Aus Sicherheitsgründen ausgeblendet. Leer lassen, um das aktuelle Secret beizubehalten.",
      },
    },
    tags: {
      name: "Schlagwort |||| Schlagworte",
      fields: {
        name: "Name",
      },
    },
    tax_rates: {
      name: "Umsatzsteuersatz |||| Umsatzsteuersätze",
      fields: {
        amount: "Prozentsatz",
        untdid_category: "UNTDID 5305 Kategorie",
        is_default: "Als Vorauswahl benutzen",
      },
    },
    users: {
      name: "Person |||| Personen",
      fields: userFields,
      is_archived: "Person ist archiviert",
      actions: {
        quick_create: "Neue Person anlegen",
        add_invoice_contact_info: "Abweichende Rechnungsanschrift hinzufügen",
        connect_moodle_account: "Moodle-Account verknüpfen |||| Moodle-Accounts verknüpfen",
        disconnect_moodle_user: "Moodle-Account trennen",
        unenroll_moodle_enrollment: "Aus Moodle-Kurs ausbuchen",
        suspend_moodle_enrollment: "In Moodle-Kurs inaktiv setzen",
        unsuspend_moodle_enrollment: "In Moodle-Kurs aktiv setzen",
        add_login: "Login hinzufügen |||| Logins hinzufügen",
        remove_login: "Login entfernen",
        change_email: "E-Mail ändern",
        add_attendee_role: "Als Teilnehmer*in kennzeichnen |||| Als Teilnehmende kennzeichnen",
        add_lecturer_role: "Als Dozent*in kennzeichnen |||| Als Dozierende kennzeichnen",
        remove_attendee_role: "Teilnehmenden-Datensatz entfernen",
        remove_lecturer_role: "Dozierenden-Datensatz entfernen",
        create_interest: "Interesse hinzufügen",
      },
      login: {
        name: "Name",
        email: "E-Mail",
        comment: "Bemerkung",
      },
      gender: {
        male: "Männlich",
        female: "Weiblich",
        non_binary: "Divers",
      },
    },
    user_moodle_users: {
      name: "Moodle-Account Verknüpfung |||| Moodle-Account Verknüpfungen",
    },
    user_list_configurations: {
      actions: {
        rename: "Umbennen",
        manage_filters: "Filter anzeigen",
        save_as_new: "Als neue Ansicht speichern",
        save_view: "Ansicht speichern",
        save_changes: "Änderungen speichern",
      },
      hints: {
        error_loading_configuration: "Fehler beim Laden der benutzerdefinierten Ansichten",
      },
    },
    staff_members: {
      name: "Mitarbeiter*in |||| Mitarbeitende",
      is_archived: "Dieser Mitarbeitende ist archiviert",
      fields: {
        ...userFields,
        roles: "Berechtigungsgruppen",
        is_2fa_required: "Zwei-Faktor-Authentifizierung erforderlich",
        color: "Farbe",
        email_senders: "Zugewiesene E-Mail-Absender",
      },
    },
    two_factor: {
      name: "Zwei-Faktor-Authentifizierung",
      actions: {
        reset_2fa: "2FA zurücksetzen",
      },
      confirm: "Zwei-Faktor-Authentifizierung wirklich zurücksetzen?",
      success: "Zwei-Faktor-Authentifizierung erfolgreich zurückgesetzt",
      error: "Zwei-Faktor-Authentifizierung konnte nicht zurückgesetzt werden.",
    },
    custom_field_content_types: {
      name: customFieldContentTypeName,
      content_types: {
        organization_users: "Organisationspersonen",
      },
      fields: {
        resource: "Datentyp",
        slug: "Identifikator",
        custom_fields: customFieldContentTypeName,
      },
    },
    custom_fields: {
      name: "Erweitertes (Stammdaten-)Feld |||| Erweiterte (Stammdaten-)Felder",
      array_input_fields: {
        custom_fields: "Feld |||| Felder",
      },
      actions: {
        add_field: "Feld hinzufügen",
        add_custom_field_section: "Bereich hinzufügen",
      },
      notification: {
        slug_not_unique: "Das Label / der Identifikator sind nicht einzigartig.",
      },
      headlines: {
        attendee_fields: "Teilnehmende-Felder",
        booking_fields: "Buchungs-Felder",
      },
      fields: {
        label: "Label",
        slug: "Identifikator",
        field_type: "Feldtyp",
        data_type: "Datentyp",
        width: "Breite",
        show_per_default: "Immer anzeigen",
        soft_required: "Erforderlich",
        allowed_for_enrollment: "Für Anmeldungen erlauben",
        allowed_for_order: "Für Bestellungen erlauben",
        editable_by_user: "Im Portal bearbeitbar",
        editable_by_buyer: "Bei Bestellung ausfüllbar",
        visible_for_attendees: "Für Teilnehmende im Portal anzeigen",
        visible_for_lecturers: "Für Dozierende im Portal anzeigen",
        relation_content_type: "Inhaltstyp",
        allow_multiple_select: "Mehrfachauswahl erlauben",
        field_types: {
          TEXT: "Text",
          TEXTAREA: "Textbereich",
          RICHTEXT: "Rich-Text-Editor",
          NUMBER: "Nummer",
          DATE: "Datum",
          BOOLEAN: "Ja / Nein",
          SELECT: "Auswahl",
          RELATION: "Relation",
          RELATION_MANY: "Relation (mehrere)",
        },
        field_info: {
          TEXT: "einzeiliges Textfeld",
          TEXTAREA: "mehrzeiliges Textfeld",
          RICHTEXT: "Richtext",
          NUMBER: "Nummernfeld",
          DATE: "Datumsfeld",
          BOOLEAN: "Ja / Nein Feld",
          SELECT: "Auswahlfeld",
          RELATION: "Relation",
          RELATION_MANY: "Relation (mehrere)",
        },
      },
    },
    todo_lists: {
      name: "Aufgabenliste |||| Aufgabenlisten",
      fields: {
        name: "Name",
      },
      array_input_fields: {
        todos: "Aufgaben",
      },
      actions: {
        add: "Liste erstellen",
        add_template_list: "Listenvorlage laden",
        edit: "Liste bearbeiten",
      },
    },
    todos: {
      name: "Aufgabe |||| Aufgaben",
      actions: {
        add: "Aufgabe hinzufügen",
        edit: "Aufgabe bearbeiten",
        showDone: "Zuletzt erledigte Aufgaben anzeigen",
        hideDone: "Zuletzt erledigte Aufgaben ausblenden",
      },
      fields: {
        assignee: "Zugewiesene Person",
        due_date: "Fälligkeitsdatum",
        text: "Text",
        is_done: "Erledigt",
        event__first_day: "Veranstaltung",
      },
      filters: {
        due_date__lte: "Fällig bis",
      },
      own_todos: "Meine Aufgaben",
      no_todos: "Aktuell keine offenen Aufgaben.",
      no_done_todos: "Bisher keine erledigten Aufgaben.",
      hints: {
        reorder_error: "Die neue Reihenfolge konnte nicht gespeichert werden.",
      },
    },
    user_lists: {
      name: "Liste |||| Listen",
      fields: {
        name: "Name",
        is_public: "Öffentlich",
        brevo_id: "Brevo Listen ID",
        consent_type: "Einwilligungstyp",
        users: "Personen",
        user_list: "Liste",
        description: "Beschreibung",
        brevo_list_name: "Brevo Listen-Name",
        brevo_folder: "Brevo Ordner",
        consent_given: "Einwilligung automatisch erteilen",
        no_consent: "Keine Einwilligung",
        consent_method: "Einwilligungen",
        trigger_confirmation: "Einwilligungsprozess (Double-Opt-In) auslösen",
      },
      actions: {
        add_persons: "Personen hinzufügen",
        remove_from_list: "Aus Liste entfernen",
        sync_to_brevo: "Zu Brevo synchronisieren",
        import_from_brevo: "Kontakte aus Brevo importieren",
        connect_existing_brevo_list: "Bestehende Brevo-Liste",
        connect_new_brevo_list: "Neue Brevo-Liste",
        sync_list: "Liste synchronisieren",
        save_and_sync: "Speichern und synchronisieren",
      },
      consent_dialog: {
        add_title: "Einwilligung erforderlich",
        add_message: "Diese Einwilligung akzeptieren, um zur Liste hinzugefügt zu werden?",
        accept_consent: "Akzeptieren & Liste abonnieren",
        remove_title: "Einwilligung entfernen",
        remove_message:
          "Soll auch die Einwilligung entfernt werden? Die Entfernung von der Liste erfolgt unabhängig davon.",
        keep_consent: "Einwilligung behalten",
        remove_consent: "Einwilligung entfernen",
      },
      hints: {
        brevo_sync_info:
          "Eine Brevo-Liste verknüpfen - Personen werden automatisch synchronisiert. Über den Button „Liste synchronisieren“ können Änderungen manuell übernommen werden. Es werden nur neue Daten an Brevo übertragen, nichts wird gelöscht.",
        brevo_migrate_info:
          "Die Brevo-Kontakte der hinterlegten Brevo-Liste werden in EDM importiert. Wenn Nutzer mit einer entsprechenden Login-E-Mail in EDM gefunden werden, werden diese verwendet. Andernfalls wird ein „Kontakt” in EDM angelegt.",
        unsubscribe_success: "Erfolgreich aus der Liste ausgetragen.",
        unsubscribe_failure: "Das Austragen aus der Liste ist fehlgeschlagen.",
      },
      sections: {
        subscribable: "Abonnierbare Listen",
      },
      filters: {
        consent_status: "Eingewilligt",
      },
      notifications: {
        successfully_added_users: "Person zur Liste hinzugefügt |||| Personen zur Liste hinzugefügt",
        successfully_updated_list: "Einstellungen wurde erfolgreich aktualisiert",
      },
    },
    user_list_data: {
      name: "Abonnierte Liste |||| Abonnierte Listen",
      fields: {
        combined_first_name: "Vorname",
        combined_last_name: "Nachname",
        created_at: "Hinzugefügt am",
        combined_email: "E-Mail",
        is_synced: "Synchronisiert",
        user__first_name: "Vorname",
        user__last_name: "Nachname",
        user__contact_infos__email: "E-Mail",
      },
      filters: {
        type: "Typ",
        contacts: "Kontakte",
        users: "Personen",
      },
      actions: {
        remove_consent: "Einwilligung ebenfalls löschen",
      },
      hints: {
        remove_confirm:
          "Soll diese Person wirklich von der Liste entfernt werden? Bitte beachten: Wenn eine Brevo-Liste verknüpft ist, wird die Person auch in Brevo von der Liste entfernt.",
      },
    },
  },
  page_sections: {
    actions: "Aktionen",
    orders: "Bestellungen",
    bookings: "Buchungen",
    bookings_files: "Buchungsdokumente",
    child_event_bases: "Unterangebote",
    contact_infos: "Kontaktinformationen",
    core_data: "Stammdaten",
    description: "Beschreibung",
    direct_bookings: "Direkte Buchungen",
    event_groups: "Veranstaltungsgruppen",
    events: "Veranstaltungen",
    extended: "Erweitert",
    files: "Dokumente",
    general: "Übersicht",
    groups: "Gruppen",
    high_priority_notes: "Wichtige Notizen",
    history: "Aktivität",
    image: "Bild",
    interested_users: "Interessierte",
    waiting_users: "Warteliste",
    potential_attendees: "Potenzielle Teilnehmende",
    interests: "Interessen",
    login: "Login",
    moodle: "Moodle",
    notes: "Notizen",
    password_reset: "Passwort zurücksetzen",
    prices: "Preise",
    related_notes: "Verknüpfte Notizen",
    settings: "Einstellungen",
    profile: "Profil",
    feedback_form: "Feedbackbögen",
    questions: "Fragen",
    question_groups: "Fragegruppen-Vorlagen",
    feedback: "Feedback",
    attendance: "Anwesenheit",
    activity: "Aktivität",
    twofa: "Zwei-Faktor-Authentifizierung",
    password_change: "Passwortverwaltung",
    visit_website: "Zur Webseite",
    language_versions: "Sprachvarianten",
    attendees: "Teilnehmende",
    relations: "Zuordnungen",
    emails: "Postausgang",
    persons: "Personen",
    organizations: "Organisationen",
    sales: "Berichtswesen",
  },
  menu_sections: {
    export: "Export",
    bookings: "Buchungen",
    communication: "Kommunikation",
    participants: "Teilnehmende",
    roles_access: "Rollen & Zugang",
    moodle: "Moodle",
    manage: "Verwalten",
  },
  password_reset: {
    success: "Das neue Passwort wurde gesetzt",
    failure: "Passwort setzen fehlgeschlagen. Bitte erneut anfordern.",
    submit: "Neues Passwort setzen",
    passwordsUnequal: "stimmt nicht mit Passwort überein",
    passwordEmpty: "Es fehlt ein Passwort",
    fields: {
      password: "Passwort",
      passwordConfirm: "Passwort-Bestätigung",
    },
  },
  filters: {
    attendance_event_type: "Angebotstyp",
    attendance_category: "Angebotskategorie",
    attendance_event_base: "Angebot",
    attendance_tags: "Angebotsschlagwort",
    bookings: {
      attendee_state: "Bundesland (Kommunikation)",
      attendee_state_invoice: "Bundesland (Rechnung)",
      first_event_day_from: "Veranstaltung von",
      first_event_day_to: "Veranstaltung bis",
      created_at_from: "Eingebucht von",
      created_at_to: "Eingebucht bis",
      group_bookings: "Gruppenbuchungen",
      booking_number: "Buchungsnummer",
      event_in: "Veranstaltungen",
      context: "Umgebung",
      order_status: "Bestellstatus",
      order_organization: "Organisation (Bestellung)",
    },
    categories: {
      has_parent_category: "Hat Überkategorie",
      parent_category_isnull: "Ist Überkategorie",
    },
    context: "Umgebung",
    current: "Laufende",
    created_at_from: "Erstellt von",
    created_at_to: "Erstellt bis",
    custom_field_date_from: "%{label} ab",
    custom_field_date_to: "%{label} bis",
    events: {
      first_day_from: "Termin ab",
      first_day_to: "Termin bis",
      number_or_event_base_title: "Nummer / Angebotstitel",
      fully_booked: "Voll belegt",
      modules: "Module",
      hide_modules: "Ohne Module",
      modules_only: "Nur Module",
    },
    groups_only: "Nur Gruppen",
    have_attended: "Teilgenommen",
    history: {
      from: "Von",
      to: "Bis",
      changed_by: "Geändert von",
      resource: "Typ",
    },
    invoices: {
      is_paid: "Ist bezahlt",
    },
    is_archived: "Archiviert",
    is_self_created: "Extern angelegt",
    is_bookable: "Buchbar",
    is_public: "Öffentlich",
    name: "Name",
    search: "Suche",
    solo_event_bases_only: "Nur Einzelangebote",
    solo_events_only: "Nur Einzelveranstaltungen",
    users: userAndEnrollmentFilters,
    upcoming: "Anstehende",
    user_list: "Liste",
    waitinglist_events: "Wartelisten Veranstaltungen",
    valid_booking_event: "Eingebuchte Veranstaltungen",
    consent_type: "Einwilligungstyp",
    completion_status: "Versandstatus",
    incomplete_email_jobs: "Nur unvollständige",
    complete_email_jobs: "Nur vollständige",
    organizations: "Organisationen",
  },
  hints: {
    event_date_details_inherited: "Ausgegraute Angaben stammen aus den Stammdaten der Veranstaltung.",
    all_price_types_taken:
      "Für jeden Preistyp wurde ein Preis angelegt. Um mehr Preise hinzufügen zu können, muss zunächst ein zusätzlicher Preistyp angelegt werden.",
    user_without_email_present:
      "Ausgewählter Datensatz benötigt eine E-Mail-Adresse. |||| Alle ausgewählten Datensätze benötigen eine E-Mail-Adresse.",
    accounting_invoice_already_present: "Eine Rechnung mit dieser Rechnungsnummer wurde schon übertragen.",
    child_of: "enthalten in",
    custom_field_models_present: "Es gibt schon %{resource} bei denen %{field} gesetzt ist.",
    delete_invoice_with_children:
      "Löschen einer Rechnung ist nur möglich, wenn keine weiteren Rechnungen zu dieser vorhanden sind.",
    disabled_add_dates:
      "Die Termine einer Veranstaltungsgruppe werden aus den Terminen der dazugehörigen Veranstaltungen generiert.",
    event_bulk_update:
      "Ausgefüllte Felder werden bei allen ausgewählten Veranstaltungen überschrieben. Leere Felder bleiben unverändert, untergeordnete Veranstaltungen werden nicht mit geändert.",
    unchanged: "Unverändert",
    event_status_label: "Status: %{status}",
    files_are_private:
      "Diese Datei ist privat und kann nur von hier aus abgerufen werden. |||| Diese Dateien sind privat und können nur von hier aus abgerufen werden.",
    files_are_public:
      "Diese Datei ist öffentlich verfügbar und kann von allen gesehen werden, die den Link dazu haben. |||| Diese Dateien sind öffentlich und können von allen gesehen werden, die den Link dazu haben.",
    group_bookings_selected: "Es sind Gruppenbuchungen ausgewählt",
    invoice_override_prices:
      "Normalerweise wird zur Erstellung der Rechnung der aktuelle Preis der ausgewählten Buchung benutzt |||| Normalerweise werden zur Erstellung der Rechnungen die aktuellen Preise der ausgewählten Buchungen benutzt",
    is_event_group: "Veranstaltungsgruppe",
    is_event_base_group: "Angebotsgruppe",
    is_group: "Gruppe",
    is_group_booking: "Gruppenbuchung",
    link_to_event_base: "Zur Angebotsseite",
    external_sender_sync_hint:
      "Bitte nur angeben, wenn der Absender bereits bei Brevo existiert und nicht neu angelegt werden soll",
    sender_delete_message: "Diesen Absender wirklich löschen?",
    sender_delete_external: "Auch bei externem E-Mail-Dienst (Brevo) löschen",
    login: {
      all_users_have_login: "%{resource} hat bereits einen Login |||| Alle %{resource} haben bereits einen Login",
      created: "Login erstellt",
      email_absent: "Keine Login E-Mail vorhanden",
      email_exists:
        'Wenn die Login E-Mail schon existiert, können die Personen mit der "Zusammenführen"-Funktion zusammengeführt werden.',
      not_all_users_have_login: "%{resource} hat noch keinen Login |||| Nicht alle %{resource} haben einen Login",
      present: "Login vorhanden",
      will_be_created: "Login wird erstellt",
      email_empty: "Login kann nur mit gültiger E-Mail erstellt werden",
      consent_info:
        "Durch das Anlegen der Logins geben die Personen automatisch ihre Einwilligung zur Nutzung des Teilnehmenden/Dozierenden-Portals. Es findet kein Double-Opt-In Prozess statt. Bitte sicherstellen, dass dies so gewünscht ist.",
      remove_confirm:
        "Entfernt den Login von %{name}. Der Personendatensatz bleibt erhalten; nur der Zugang zum Teilnehmenden-/Dozierenden-Portal wird entfernt.",
    },
    role: {
      remove_attendee_confirm:
        "Entfernt den Teilnehmenden-Datensatz von %{name}. Der Personen-Datensatz bleibt erhalten; nur die spezifischen Daten (z.B. Zielgruppe, Debitorennummer, erweiterte Felder) werden gelöscht.",
      remove_lecturer_confirm:
        "Entfernt den Dozierenden-Datensatz von %{name}. Der Personen-Datensatz bleibt erhalten; nur die spezifischen Daten (z.B. Honorar, Qualifikationen, erweiterte Felder) werden gelöscht.",
    },
    moodle: {
      all_connected: "%{resource} ist bereits verknüpft |||| Alle %{resource} sind bereits verknüpft",
      connect_error: "Verknüpfen fehlgeschlagen",
      connected: "ist bereits verknüpft",
      course_enrolled_users_count: "%{enrolledUsersCount} von %{bookingsCount} Teilnehmenden eingebucht",
      course_without_enrollments: "Bisher wurden keine Teilnehmenden in diesen Kurs eingebucht.",
      not_all_users_have_account: "Nicht alle %{resource} haben einen Moodle-Account",
      no_linked_courses: "Bisher wurden keine Moodle-Kurse mit dieser Veranstaltung verknüpft",
      present: "wird mit bereits bestehendem Moodle-Account verknüpft (%{info})",
      will_be_created: "wird neu bei Moodle angelegt",
      has_moodle_account: "Moodle-Account verknüpft",
    },
    payment: {
      self_managed: "Ist Direktzahlung",
    },
    event_type_necessary_for_resource: "Der Angebotstyp muss gesetzt sein, bevor %{resource} angelegt werden können.",
    no_prices_present: "Für diese Veranstaltung sind keine Preise vorhanden.",
    non_bookable_group_child: "Veranstaltung ist nicht einzeln buchbar",
    update_main_contact_info: "Kommunikationsadresse aus Anmeldung für Person übernehmen",
    update_invoice_contact_info: "Rechnungsadresse aus Anmeldung für Person übernehmen",
    update_invoice_dispatch_contact_info: "Rechnungsversandsadresse aus Anmeldung für Person übernehmen",
    all_users_have_login: "Alle %{resource} haben einen Login",
    login_email_exists:
      'Wenn die Login E-Mail schon existiert, können die Personen mit der "Zusammenführen"-Funktion zusammengeführt werden.',
    login_email_absent: "Keine Login E-Mail vorhanden",
    sub_record_fetch_error:
      "%{resource} für %{parentResource} konnte nicht geladen werden. |||| %{resource} für %{parentResource} konnten nicht geladen werden.",
    report: {
      data_info_headline: "Datengrundlage",
      data_info_content:
        'Die zugrundeliegenden Daten werden abhängig vom ausgewählten Zeitraum nach unterschiedlichen Veranstaltungs-Status gefiltert. Für Zeiträume in der Vergangenheit werden (Buchungen von) Veranstaltungen mit Status "GO" und "Erledigt" genutzt. Für Zeiträume in der Zukunft hingegen werden (Buchungen von) Veranstaltungen mit Status "Angeboten" und "GO" verwendet.',
      data_info_headline_bookings: "Buchungen",
      data_info_content_bookings:
        "Ob eine Buchung für den ausgewählten Zeitraum berücksichtigt wird, hängt dabei stets vom Starttermin der Veranstaltung ab, das Buchungsdatum selbst spielt keine Rolle.",
    },
    bulk_selection_limit_exceeded:
      "Mehr als 1000 Einträge ausgewählt. Dies kann zu Fehlern in der Verarbeitung führen.",
    similar_attendee_already_exists:
      "Es existieren für diese Veranstaltung bereits Buchungen mit ähnlichen Daten für folgende Personen: %{names}. Bitte sicherstellen, dass es sich nicht um eine unabsichtliche Doppelbuchung handelt.",
    permission_denied_info:
      "Für die durchgeführte Aktion liegen keine Berechtigungen vor. Sollten zusätzliche Berechtigungen benötigt werden, ist eine Kontaktaufnahme mit einem Administrator erforderlich.",
    current_user_roles: "Aktuellen Berechtigungsgruppen",
    custom_field_select_already_used:
      "Der Wert für dieses Feld ist bereits bei %{count} %{resource} hinterlegt. Soll die Auswahl trotzdem bearbeitet werden? Alte Werte bleiben bei Änderungen erhalten und werden nicht aktualisiert.",
    feedback_module_of: "Feedbackmodul des",
    feedback_not_found_headline: "Es konnte kein passender Feedback-Bogen für diesen Link gefunden werden",
    feedback_not_found_info:
      "Bitte prüfen Sie, ob der Link korrekt ist. Möglicherweise ist auch die Gültigkeit des Links abgelaufen.",
    copied_to_clipboard: "In Zwischenablage kopiert.",
    custom_field_slug_already_exists_elswhere:
      "Dieser Slug existiert bereits für %{resource}. Die Dopplung kann zur Folge haben, dass Daten mit diesem Slug bei der Anmeldung sowohl für die Buchung als auch für die Person übernommen werden. Falls dies nicht beabsichtigt ist, sollte ein anderer Slug verwendet werden.",
    enrollment_already_approved: "Diese Anmeldung wurde bereits bearbeitet.",
    enrollment_not_found_headline: "Es konnte leider keine passende Anmeldung für diesen Link gefunden werden",
    error_info:
      "Leider ist bei der Bearbeitung der Anfrage ein Fehler aufgetreten. Dies deutet in der Regel auf ein technisches Problem innerhalb der Anwendung hin. Wenn der Fehler weiterhin besteht, bitte unseren Support kontaktieren.",
    not_found_info:
      "Leider konnte die aufgerufene Seite nicht gefunden werden. Bitte die URL überprüfen oder im Zweifel den Support kontaktieren.",
    only_canceled_bookings_can_be_archived: "Nur stornierte Buchungen können archiviert werden.",
    add_lecturers_to_event_children: "Dozent*in zusätzlich diesen Unterveranstaltungen zuweisen:",
    change_event_base_with_child_or_parent:
      "Diese Veranstaltung ist Teil einer Veranstaltungsgruppe. Bitte beachten Sie, dass nur das Angebot der aktuellen Veranstaltung geändert wird. Übergeordnete oder untergeordnete Veranstaltungen müssen separat bearbeitet werden.",
  },
  validations: {
    url: "URL ist nicht gültig (muss mit http:// oder https:// beginnen)",
    slug_chars: "nur Buchstaben, Zahlen und - gültig",
    registration_begin_after_deadline: "Anmeldebeginn muss vor oder gleich dem Anmeldeschluss sein",
    registration_deadline_before_begin: "Anmeldeschluss muss nach oder gleich dem Anmeldebeginn sein",
    first_day_after_last_day: "Erster Tag muss vor oder gleich dem letzten Tag sein",
    last_day_before_first_day: "Letzter Tag muss nach oder gleich dem ersten Tag sein",
    attendees_min_greater_than_max:
      "Minimale Teilnehmerzahl muss kleiner oder gleich der maximalen Teilnehmerzahl sein",
    attendees_max_less_than_min: "Maximale Teilnehmerzahl muss größer oder gleich der minimalen Teilnehmerzahl sein",
    start_time_after_end_time: "Startzeit muss vor oder gleich der Endzeit sein",
    end_time_before_start_time: "Endzeit muss nach oder gleich der Startzeit sein",
  },
  confirmations: {
    moodle: {
      disonnect_user: "%{name} (%{email}) von Moodle trennen?",
      connect_user_create: "Soll ein Account für %{name} (%{email}) bei Moodle angelegt werden?",
      connect_user_with_existing:
        "Ein Account mit der E-Mail-Adresse %{email} ist bei Moodle bereits angelegt. Soll der Account trotzdem verknüpft werden?",
      unenroll_moodle_enrollments:
        "Soll %{moodleUser} aus dem Kurs %{courseName} ausgebucht werden? |||| Sollen die ausgewählten Personen aus dem Kurs %{courseName} ausgebucht werden?",
      suspend_moodle_enrollments:
        "Soll %{moodleUser} im Kurs %{courseName} auf inaktiv gesetzt werden? |||| Sollen die ausgewählten Personen im Kurs %{courseName} auf inaktiv gesetzt werden?",
      unsuspend_moodle_enrollments:
        "Soll %{moodleUser} im Kurs %{courseName} auf aktiv gesetzt werden? |||| Sollen die ausgewählten Personen im Kurs %{courseName} auf aktiv gesetzt werden?",
      disonnect_course: "%{name} von Moodle trennen?",
    },
    event_title: "Empfohlene Felder für Veranstaltung nicht befüllt",
    event_text:
      "Für diese Veranstaltung wurden nicht alle empfohlenen Felder befüllt. Dies kann beispielsweise zur unvollständigen Darstellung der Veranstaltung auf der Webseite führen. Folgende empfohlenen Felder wurden nicht befüllt:",
    event_fields: "Veranstaltungsfelder:",
    event_base_change_bookings_present: "Es sind Buchungen vorhanden",
    event_base_change_explanation:
      "Durch das Ändern des Angebots kann sich die inhaltliche Beschreibung für diese Veranstaltung ändern. Soll das Angebot für diese Veranstaltung trotzdem geändert werden?",
    event_base_fields: "Angebotsfelder:",
    event_save_anyway: "Trotzdem veröffentlichen",
    event_save_draft: "Als Entwurf speichern",
    event_base_save_anyway: "Trotzdem speichern",
    event_base_failed_soft_validation_title: "Empfohlene Felder für Angebot nicht befüllt",
    event_base_failed_soft_validation_text:
      "Für dieses Angebot wurden nicht alle empfohlenen Felder befüllt. Dies kann beispielsweise zur unvollständigen Darstellung der Veranstaltung auf der Webseite führen. Folgende empfohlenen Felder wurden nicht befüllt:",
    delete_invoice:
      'Bitte beachten Sie, dass mit Klick auf "Bestätigen" die ausgewählte Rechnung unwiderruflich gelöscht wird. Das kann buchhalterische und/oder steuerliche Probleme verursachen, falls die Rechnung bereits im Umlauf sein sollte.',
    delete_custom_field:
      "Soll dieses Feld wirklich gelöscht werden? Dabei werden auch alle dem Feld hinterlegten Daten unwiderruflich gelöscht.",
    delete_custom_field_section:
      "Soll dieser Bereich wirklich gelöscht werden? Dabei werden auch alle enthaltenen Felder sowie die zu den Feldern hinterlegten Daten unwiderruflich gelöscht.",
    delete_following_custom_fields: "Folgende Felder (inkl. hinterlegte Daten) werden ebenfalls gelöscht:",
    delete_custom_field_with_data:
      "Es ist ein Datensatz vorhanden bei dem %{label} gesetzt ist. |||| Es sind %{smart_count} Datensätze vorhanden bei denen %{label} gesetzt ist.",
    delete_user:
      "Wenn diese Aktion ausgeführt wird, werden alle Benutzerdaten unwiderruflich gelöscht. Ausgenommen davon sind Buchungen, dazugehörige Rechnungen und versendete E-Mails. Käufer offener Bestellungen können erst gelöscht werden, wenn die Bestellung storniert oder abgeschlossen ist.",
    delete_organization:
      "Die Organisation, ihre Kontaktdaten, Mitglieder und Zusatzfelder werden unwiderruflich gelöscht. Organisationen mit Bestellungen können nicht gelöscht, sondern nur archiviert werden.",
    edit_invoice:
      "Achtung: Es wird eine bereits existierende Rechnung bearbeitet. Das kann buchhalterische und/oder steuerliche Probleme verursachen, falls die Rechnung bereits im Umlauf sein sollte.",
    failed_soft_validation_title: "Empfohlene Felder nicht befüllt",
    failed_soft_validation_text:
      "Es wurden nicht alle empfohlenen Felder für diesen Datensatz befüllt. Folgende empfohlenen Felder fehlen:",
    check_values_title: "Angaben prüfen",
    check_values_text: "Bitte vor dem Speichern prüfen:",

    slug_changed_title: "Identifikator geändert",
    slug_changed_text:
      "Bestehende Beschreibungen sind über den Identifikator mit dem Beschreibungsfeld verknüpft. Sollen die bereits erfassten Beschreibungen dieses Angebotstyps auf den neuen Identifikator umgestellt werden? Andernfalls verlieren sie ihre Verknüpfung.",
    slug_changed_move_descriptions: "Beschreibungen umstellen",
    slug_changed_keep_descriptions: "Nur Feld speichern",

    non_template_descriptions_present_title: "Beschreibungen nicht mehr gültig",
    non_template_descriptions_present_text:
      "%{smartCountDescriptions} nicht mehr mit den Beschreibungsfeldern des neuen Angebotstyps kompatibel.",
    remove_from_event_group: "Soll diese Veranstaltung wirklich aus der Veranstaltungsgruppe entfernt werden?",
    remove_from_event_base_group: "Soll dieses Angebot wirklich aus der Angebotsgruppe entfernt werden?",
    remove_lecturer_from_event: "Soll diese/r Dozent*in wirklich aus der Veranstaltung entfernt werden?",
    event_base_name_already_present: "Angebotstitel schon vorhanden",
    event_base_name_already_present_explanation:
      "Der Angebotstitel ist schon außerhalb einer Gruppe vorhanden. Deshalb kann dieses Angebot nicht aus der Gruppe entfernt werden. Bitte eines der Angebote zuerst umbenennen.",
    group_mark_as_attended:
      'Da es sich um Buchungen einer Veranstaltungsgruppe handelt, betrifft diese Aktion alle Unterveranstaltungen. Die ausgewählten Personen werden in allen Unterveranstaltungen als "hat teilgenommen" markiert.',
    group_mark_as_unattended:
      'Da es sich um Buchungen einer Veranstaltungsgruppe handelt, betrifft diese Aktion alle Unterveranstaltungen. Die ausgewählten Personen werden in allen Unterveranstaltungen als "hat nicht teilgenommen" markiert.',
    add_as_interests: 'Sollen die ausgewählten Buchungen zusätzlich als "Interessiert" hinzugefügt werden?',
    alter_bookings:
      'Die ausgewählten Personen werden in die unten ausgewählte Veranstaltung eingebucht. In der aktuellen Veranstaltung wird der Status auf "Umgebucht" gesetzt.',
    custom_field_select_edit_anyway: "Auswahl trotzdem bearbeiten",
    unsaved_changes_dialog:
      "Es wurden Änderungen am Formular vorgenommen. Soll der Dialog wirklich geschlossen werden?",
    close_dialog: "Soll der Dialog wirklich geschlossen werden?",
    delete_feedback_form:
      "Soll dieser Feedbackbogen wirklich gelöscht werden? Falls bereits Antworten für diesen Bogen existieren, werden diese ebenfalls gelöscht.",
    delete_question_group:
      "Sollen diese Fragengruppe wirklich gelöscht werden? Es werden dabei auch alle Fragen innerhalb der Fragengruppe vom Feedbackbogen entfernt. Falls bereits Antworten für die enthaltenen Fragen existieren, werden diese ebenfalls gelöscht.",
    delete_question:
      "Soll diese Frage wirklich gelöscht werden? Falls bereits Antworten für diese Frage existieren, werden diese ebenfalls gelöscht.",
    bulk_attendances_different_values: "Einige Buchungen haben bereits andere Werte für die Teilnahme hinterlegt:",
    values_will_be_overwritten: "Diese Werte werden überschrieben. Trotzdem fortfahren?",
  },
  settings: {
    relative_commission_per_booking: {
      name: "Relative Provision pro Buchung",
      description: "Dieser Faktor wird benutzt, um die relative Provision pro Buchung zu berechnen.",
    },
    automated_data_deletion_active: {
      name: "Automatisches Löschen von Nutzer- und Rechnungsdatensätzen",
      description: "Das automatische Löschen von Nutzer- und Rechnungsdatensätzen EDM-weit aktivieren.",
    },
    automated_data_deletion_user_threshold_days: {
      name: "Benutzerlöschfrist in Tagen",
      description: "Nach wievielen Tagen Nutzer automatisch gelöscht werden.",
    },
    automated_data_deletion_invoice_threshold_days: {
      name: "Rechnungs Löschfrist in Tagen",
      description: "Nach wie vielen Tagen Rechnungen automatisch gelöscht werden.",
    },
    relative_commission_eur_cap_per_booking: {
      name: "Maximale relative Provision pro Buchung (€)",
      description: "Der maximale Betrag in Euro, der pro Buchung als relative Provision berechnet werden kann.",
    },
    fix_commission_per_booking: {
      name: "Fixe Provision pro Buchung (€)",
      description: "Dieser Betrag wird pro Buchung zusätzlich zu der relativen Provision berechnet.",
    },
    fix_commission_per_month: {
      name: "Fixe Provision pro Monat (€)",
      description: "Dieser Betrag wird fix pro Monat berechnet.",
    },
    default_event_location: {
      name: "Standard-Veranstaltungsort",
      description: "Dieser Veranstaltungsort wird beim Erstellen von Veranstaltungen vorausgewählt.",
    },
    default_event_type: {
      name: "Standard-Angebotstyp",
      description: "Dieser Angebotstyp wird beim Erstellen von Angeboten vorausgewählt.",
    },
    default_price_type: {
      name: "Standard-Preistyp",
      description: "Dieser Preistyp wird beim Erstellen von Buchungen vorausgewählt.",
    },
    logo_path: {
      name: "Logo-URL",
      description: "Die URL zum gewünschten Logo im Anmelde-Bereich.",
    },
    login_text: {
      name: "Login Text",
      description: "Info-Text, welcher bei der Anmeldung angezeigt wird.",
    },
    imprint_url: {
      name: "Impressums-URL",
      description: "Die URL zum Impressum im Anmelde-Bereich.",
    },
    data_privacy_url: {
      name: "Datenschutz-URL",
      description: "Die URL zum Datenschutz im Anmelde-Bereich.",
    },
    stripe_api_key: {
      name: "API Key",
      description: "Der von Stripe erhaltene API Key.",
    },
    stripe_cancel_redirect: {
      name: "Weiterleitung bei Fehler",
      description: "Die URL, zu der nach einem Abbruch des Checkouts, weitergeleitet wird.",
    },
    stripe_success_redirect: {
      name: "Weiterleitung bei Erfolg",
      description: "Die URL, zu der nach einem erfolgreichen Checkout weitergeleitet wird.",
    },
    stripe_invoice_name: {
      name: "Rechnungsname",
      description: "Der Bezeichner, der für die Rechungsdokumente verwendet wird.",
    },
    stripe_webhook_secret: {
      name: "Webhook secret",
      description: "Das Webhook secret von Stripe.",
    },
    scopevisio_customer_id: {
      name: "Scopevisio Customer ID",
      description: "Die Scopevisio Kundennummer",
    },
    scopevisio_refresh_token: {
      name: "Scopevisio Refresh Token",
      description: "Dieses Token wird benutzt um auf die Scopevisio API zuzugreifen",
    },
    scopevisio_webhook_secret: {
      name: "Scopevisio Webhook Secret",
      description: "Wird im Header X-Scopevisio-Webhook-Secret erwartet",
    },
    moodle_api_token: {
      name: "Moodle API Token",
      description: "Dieses Token wird benutzt um auf die Moodle API zuzugreifen",
    },
    moodle_attendee_role_id: {
      name: "Teilnehmer*in Rolle",
      description: "Dieses Rolle wird Teilnehmenden beim Einbuchen zugewiesen",
    },
    moodle_host: {
      name: "Moodle Host",
      description: "Der Hostname des Servers, auf dem die Mooodle Instanz läuft",
    },
    moodle_lecturer_role_id: {
      name: "Dozent*in Rolle",
      description: "Dieses Rolle wird Dozierenden beim Einbuchen zugewiesen",
    },
    moodle_service: {
      name: "Moodle Webservice",
      description: "Der Name des Webservices, der auf dem Moodle-Server hinterlegt ist",
    },
    moodle_url: {
      name: "Moodle URL",
      description: "URL der Moodle-Instanz (wird für Verlinkungen verwendet)",
    },
    custom_theme: {
      name: "Custom-Theme für EDM-Portal",
      description: "Material UI Theme für das EDM-Portal (Teilnehmende & Dozierende).",
    },
    days_lecturers_may_change_attendance_after_event: {
      name: "Bearbeitungsende für Teilnahme durch Dozierende",
      description: "Wieviel Tage nach Veranstaltungsende dürfen Dozierende die Teilnahme noch bearbeiten",
    },
    is_portal_active: {
      name: "EDM-Portal für Teilnehmende und Dozierende",
      description: "EDM-Portal für Teilnehmende und Dozierende aktivieren",
    },
    website_url: {
      name: "Webseiten-URL",
      description: "Die URL zur eigenen Webseite. Diese wird beispielsweise im Portal verlinkt.",
    },
    lecturer_booking_export_active: {
      name: "Dozierende dürfen Buchungen exportieren",
      description: "Soll im Portal für Dozierende eine Export-Funktion für Buchungen angezeigt werden?",
    },
    lecturer_emailing_active: {
      name: "Dozierende dürfen E-Mails senden",
      description: "Soll im Portal für Dozierende eine E-Mail-Funktion angezeigt werden?",
    },
    favicon_url: {
      name: "Favicon-URL",
      description: "Die URL zum gewünschten Favicon für öffentliche Seiten.",
    },
    read_emails_independent_of_sender: {
      name: "Mitarbeitende dürfen alle E-Mails einsehen",
      description: "Mitarbeitende dürfen E-Mails unabhängig vom Absender einsehen.",
    },
    storefront_config: {
      name: "Storefront Konfiguration",
      description: "JSON-Konfiguration für Storefront-Applikation",
    },
    public_portal_registration: {
      name: "Öffentlich Registrierungsformular (Portal)",
      description: "Soll das Registrierungsformular für das Portal öffentlich zugänglich sein?",
    },
    read_only: "Diese Einstellung kann hier nicht verändert werden.",
    default_bcc: {
      name: "Standard-BCC",
      description: "E-Mail-Adresse, die bei allen ausgehenden E-Mails als BCC eingetragen wird.",
    },
    frontend_event_base_path: {
      name: "Angebotspfad",
      description: "URL-Pfad für Angebots-Detailseiten. Platzhalter: {slug}",
    },
    frontend_event_path_segment: {
      name: "Veranstaltungspfad",
      description: "URL-Pfadsegment für einzelne Veranstaltungen. Platzhalter: {id}",
    },
    groups: {
      general: "Grundkonfiguration",
      portal: "Portal",
      defaults: "Standardwerte",
      storefront: "Storefront",
      orders: "Bestellungen & Rechnungen",
    },
    order_validation_capacity: {
      name: "Kapazität prüfen",
      description: "Prüft, ob eine Bestellung die maximale Teilnehmerzahl einer Veranstaltung überschreitet.",
    },
    order_validation_registration_window: {
      name: "Anmeldezeitraum prüfen",
      description: "Prüft, ob eine Bestellung im Anmeldezeitraum einer Veranstaltung eingeht.",
    },
    order_validation_event_started: {
      name: "Veranstaltungsbeginn prüfen",
      description: "Prüft, ob eine Veranstaltung bei der Bestellung schon begonnen hat.",
    },
    order_validation_levels: {
      off: "Aus",
      internal: "Kundenbestellungen immer annehmen",
      everywhere: "Immer prüfen",
      help: "Kundenbestellungen immer annehmen: Bestellungen über Website, Anmeldeformulare und Schnittstellen werden ohne Prüfung angenommen. Der Fehler erscheint erst, wenn Mitarbeitende eine solche Bestellung bearbeiten oder bestätigen. \nImmer prüfen: Auch Kundenbestellungen werden abgelehnt.",
    },
    order_validation_billing_address: {
      name: "Prüfung 'Rechnungsadresse vorhanden' erzwingen",
      description:
        "Bestellungen ablehnen, die berechnet werden, wenn keine nutzbare Rechnungsadresse vorliegt. Bei Bestellungen einer Organisation zählt die Adresse der Organisation. Gilt nur für automatisch verarbeitete Bestellungen; bei manueller Verarbeitung erscheint der Fehler erst beim Erstellen der Rechnung.",
    },
    order_checkout_window_minutes: {
      name: "Checkout-Zeitfenster (Minuten)",
      description: "Wie lange eine offene Bestellung Plätze während des Checkouts reserviert.",
    },
    order_manual_processing: {
      name: "Manuelle Bestellbearbeitung",
      description:
        "Wenn aktiv, bleiben Bestellpositionen offen, bis das Personal sie zu einer Buchung verarbeitet. Wenn inaktiv, werden Positionen nach Bestätigung der Bestellung automatisch gebucht. Angebotstypen können dies überschreiben.",
    },
    order_unverified_user_retention_days: {
      name: "Aufbewahrungsfrist für unverifizierte Personen (Tage)",
      description:
        "Nach wie vielen Tagen selbst angelegte, unverifizierte Personendatensätze gelöscht werden. Personen mit Buchung, offener Bestellung oder abgerechneter Position werden immer behalten. 0 = keine Löschung.",
    },
    invoice_payment_term_days: {
      name: "Zahlungsziel (Tage)",
      description:
        "Wie viele Tage nach dem Rechnungsdatum eine Rechnung fällig ist. Das Fälligkeitsdatum wird beim Erstellen der Rechnung gespeichert und an die Buchhaltung übertragen. 0 = kein Fälligkeitsdatum.",
    },
    debit_number_start_index: {
      name: "Debitorenkreis Start",
      description: "Erste Nummer, die EDM vergibt.",
    },
    debit_number_end_index: {
      name: "Debitorenkreis Ende",
      description:
        "Letzte Nummer des Bereichs. Leer = unbegrenzt. Ist der Bereich voll, schlägt das Erzeugen von Rechnungen fehl.",
    },
    organization_debit_number_start_index: {
      name: "Debitorenkreis Organisationen Start",
      description: "Optional eigener Bereich für Organisationen. Leer = Organisationen nutzen den Bereich oben.",
    },
    organization_debit_number_end_index: {
      name: "Debitorenkreis Organisationen Ende",
      description: "Letzte Nummer des Organisationsbereichs. Leer = unbegrenzt.",
    },
    debit_number_ranges: {
      help: "Bereiche, aus denen neue Debitorennummern vergeben werden. Änderungen gelten nur für neu vergebene Nummern; vergebene Nummern bleiben.",
      errors: {
        end_without_start: "Ohne Start ist kein Ende möglich.",
        end_before_start: "Das Ende muss größer oder gleich dem Start sein.",
        overlap:
          "Die Bereiche für Personen und Organisationen überschneiden sich. Ein fehlendes Ende gilt als unbegrenzt.",
      },
    },
    invoice_auto_accounting_transfer: {
      name: "Rechnungen automatisch zur Buchhaltung übertragen",
      description:
        "Wenn aktiv, werden neu erstellte Rechnungen automatisch an die Buchhaltung übertragen. Automatisch erstellte Rechnungen - bei deaktivierter manueller Bestellbearbeitung und nach erfolgreicher Online-Zahlung - werden unabhängig von dieser Einstellung übertragen.",
    },
    create_organization_with_account: {
      name: "Organisationserstellung bei Registrierung anbieten",
      description: "Nutzer*innen können bei der Kontoregistrierung eine Organisation anlegen.",
    },
    cancellation_period: {
      name: "Widerrufsfrist (Tage)",
      description:
        "Anzahl der Tage ab Buchung, bis zu denen eine Stornierung möglich ist. 0 = keine Stornierung möglich.",
    },
    cancellation_contact_email: {
      name: "Stornierungskontakt-E-Mail",
      description:
        "E-Mail-Adresse, an die bei einer Stornierungsanfrage im Portal eine Benachrichtigung gesendet wird.",
    },
    headlines: {
      emailing: "E-Mails",
      links: "Verlinkungen",
      lecturers: "Dozierende",
      cancellation: "Stornierung",
      data_deletion: "Datenlöschung",
      order_processing: "Bestellbearbeitung",
      availability_checks: "Verfügbarkeitsprüfungen",
      invoicing: "Rechnungen",
      debit_number_ranges: "Debitorenkreise",
    },
  },
  sidebar: {
    admin_section: "Administration",
    accounting_section: "Verkauf",
    users_section: "Personen",
    imprint: "Impressum",
    data_privacy: "Datenschutz",
    info: "Info",
    administration: {
      main_data: "Stammdaten",
      user_management: "Zugriff",
      template_management: "Vorlagen",
      settings: "Einstellungen",
    },
  },
  empty_state: "Keine %{entity} vorhanden.",
  no_category: "Keine Kategorie",
  no_date: "Kein Termin",
  no_event_base: "Kein Angebot",
  no_value: "Kein Wert",
  no_state: "Kein Bundesland",
  oclock: "%{time} Uhr",
  all: "Alle",
  already_taken: "ist bereits vergeben",
  born: "geb. %{date}",
  no_name: "Ohne Namen (#%{id})",
  "Bad Request": "Anfrage fehlgeschlagen",
  Forbidden: "Keine Berechtigung für diese Aktion",
  "Not Found": "Datensatz nicht gefunden",
  Unauthorized: "Nicht erlaubt",
  "Internal Server Error": "Serverseitiger Fehler",
  "NetworkError when attempting to fetch resource.": "Anfrage wegen Netzwerkfehler fehlgeschlagen.",
  invalid_grant: "Anmeldedaten sind ungültig",
  login_error: "Anmeldung momentan nicht möglich",
  login_error_message:
    "Leider ist bei der Kommunikation mit dem Server ein Fehler aufgetreten. Bitte erneut versuchen oder an die Administratoren wenden.",
  try_again: "Erneut versuchen",
  enlarge: "Vergrößern",
  shrink: "Verkleinern",
  notification: {
    login_created: "Login hinzugefügt |||| Logins hinzugefügt",
    connect_success: "%{entity} erfolgreich verknüpft",
    disconnect_success: "%{entity} erfolgreich getrennt",
    disconnect_error: "%{entity} trennen fehlgeschlagen",
    moodle: {
      connect_error: "%{entity} verknüpfen fehlgeschlagen",
      enrollment_success: "%{resource} erfolgreich eingebucht",
      enrollment_error: "%{resource} einbuchen fehlgeschlagen",
      unenroll_success: "%{resource} erfolgreich ausgebucht",
      unenroll_error: "%{resource} ausbuchen fehlgeschlagen",
      suspend_success: "%{resource} erfolgreich auf inaktiv gesetzt",
      suspend_error: "%{resource} auf inaktiv setzten fehlgeschlagen",
      unsuspend_success: "%{resource} erfolgreich auf aktiv gesetzt",
      unsuspend_error: "%{resource} auf aktiv setzten fehlgeschlagen",
      create_error: "%{entity} konnte nicht angelegt werden",
    },
    remove_from_group_error: "Entfernen aus der Gruppe fehlgeschlagen",
    remove_from_group_success: "Aus der Gruppe entfernt",
    upload_error: "Beim Hochladen ist ein Fehler aufgetreten.",
    upload_error_reason: "Hochladen fehlgeschlagen: %{reason}",
    unsupported_file_type: "Dieser Dateityp wird nicht unterstützt. Erlaubte Typen: %{types}.",
    upload_success: "Hochladen erfolgreich",
    check_for_password_reset: "E-Mail zum Passwort zurücksetzen gesendet",
    password_reset_error: "E-Mail-Adresse ungültig oder nicht vorhanden",
    delete_error: "Fehler beim Löschen des Datensatzes",
    delete_price_enrollment_error:
      "Der Preis kann nicht gelöscht werden, da %{entityCount} unbearbeitete %{enrollment} mit diesem Preis existieren.",
    duplicate_todos_error: "Fehler beim Duplizieren der Aufgaben. Die Veranstaltung wurde dennoch erstellt.",
  },
  archiving: {
    archive: "Archivieren",
    archive_confirm: "%{resource} wirklich archivieren? |||| %{entityCount} %{resource} archivieren?",
    archive_success: "%{resource} erfolgreich archiviert",
    archive_error: "Archivierung fehlgeschlagen",
    events_affected: "Betroffene Veranstaltungen: ",
    unarchive: "Wiederherstellen",
    unarchive_confirm: "%{resource} wirklich wiederherstellen? |||| %{entityCount} %{resource} wiederherstellen?",
    unarchive_success: "%{resource} erfolgreich wiederhergestellt",
    unarchive_error: "Wiederherstellung fehlgeschlagen",
    valid_bookings_affected: "Betroffene gültige Buchungen: ",
  },

  editor: {
    hints: {
      bold: "Fett",
      italic: "Kursiv",
      heading1: "Überschrift 1",
      heading2: "Überschrift 2",
      heading3: "Überschrift 3",
      undo: "Schritt zurück",
      redo: "Schritt vor",
      paragraph: "Absatz",
      list: "Liste",
      numberedList: "Nummerierte Liste",
      todoList: "Aufgabenliste",
      link: "Link",
    },
  },
  emailing: {
    attachments: "Anhänge",
    attendance_confirmation: "Teilnahmebestätigung schicken",
    body: "Inhalt",
    booking_confirmation: "Buchungsbestätigung schicken",
    order_confirmation: "Eingangsbestätigung schicken",
    content_blocks: "Inhaltsblöcke",
    event_blocks: "Veranstaltungsblöcke",
    email_interested_users: "Interessent*in anschreiben |||| Interessierte anschreiben",
    feedback: "Feedbackbogen versenden",
    invoice_kind: "Rechnungstyp",
    invoice_not_found:
      "Eine Rechnung konnte dem Empfänger nicht zugeordnet werden und kann deshalb nicht verschickt werden.",
    no_body: "Der Inhalt der E-Mail ist aktuell leider nicht abrufbar.",
    open_errors: "Unbearbeitete Fehler",
    related_records: "Verknüpfte Datensätze",
    archive_job_hint: "Alle E-Mails dieses Versands werden ebenfalls archiviert.",
    unarchive_job_hint:
      "Alle E-Mails dieses Versands werden ebenfalls wiederhergestellt, auch die einzeln archivierten.",
    no_template: "Keine Vorlage ausgewählt",
    no_receivers: "Keine gültigen Empfänger vorhanden",
    no_templates_for_scope: "Es sind noch keine E-Mail-Vorlagen für diesen Bereich hinterlegt.",
    no_assigned_senders: "Für diesen Nutzer wurden noch keinen E-Mail-Absender zugewiesen.",
    receivers: "Empfänger",
    send: "Senden",
    send_email: "E-Mail senden",
    recipients_label: "Empfänger:",
    sendtest: "Test senden",
    signature: "Signatur",
    subject: "Betreff",
    sender: "Absender",
    error: "Fehler beim Senden der E-Mail |||| Fehler beim Senden der E-Mails",
    sent_to_sib_at: "An Brevo übertragen um",
    success: "E-Mail(s) erfolgreich gesendet",
    template: "Vorlage",
    test_error: "Fehler beim Senden der Test-E-Mail",
    test_success: "Test-E-Mail erfolgreich gesendet",
    testaddress: "Test-E-Mail-Adresse",
    with_generated_document: "Das generierte Dokument wird automatisch als Anhang versendet.",
    invoice_document_missing:
      "Für %{smart_count} Rechnung liegt noch kein Dokument vor; sie wird ohne Anhang versendet. |||| Für %{smart_count} Rechnungen liegt noch kein Dokument vor; sie werden ohne Anhang versendet.",
    upload_attachment: "Anhang hochladen",
    generated_documents: "Generierte Dokumente",
    preview: "Vorschau",
    preview_error: "Fehler beim Generieren der Vorschau: %{error}",
    scheduled_dispatch: "Geplanter Versand",
    scheduled_send: "Datum übernehmen",
    day_before_event_start: "1 Tag vor Veranstaltungsbeginn",
    day_after_event_end: "1 Tag nach Veranstaltungsende",
    scheduled_emails: "Geplante E-Mail |||| Geplante E-Mails",
    waiting_list_confirmation: "Bestätigung für Warteliste schicken",
    contact_type: {
      invoice: "Rechnungsadressen",
      communication: "Kommunikationsadressen",
    },
    parties: {
      recipient: "Empfänger",
      attendee: "Teilnehmer:in",
      invoice_recipient: "Rechnungsempfänger",
    },
    show_recipient_addresses: "Empfängeradresse anzeigen |||| %{smart_count} Empfängeradressen anzeigen",
    cc_info: "Für alle E-Mails (nicht nur für eine einzelne) wird ein Cc gesetzt.",
    use_custom_email: "Abweichende E-Mail-Adresse",
    use_recipient_selection: "Empfängerauswahl",
    total_file_size_exceeded_warning:
      "Die Größenbeschränkung für E-Mails beträgt 20 MB, Anhang und E-Mail-Inhalt eingeschlossen.",
  },
  merging: {
    error: "Zusammenführen fehlgeschlagen",
    merge_with: "Zusammenführen",
    person_to_merge: "Zusammenführen mit",
    success: "Zusammenführen erfolgreich",
    login_warning: "Die ausgewählte Person besitzt einen Login.",
    info: {
      title: "Was passiert beim Zusammenführen?",
      deletion_and_base_data:
        "Die ausgewählte Person wird gelöscht. Fehlende Grunddaten (Titel, Geschlecht, Geburtsdatum etc.) werden vom zusammenzuführenden Nutzer ergänzt.",
      lecturer_and_attendee_data:
        "Teilnehmer- und Dozenteneigenschaften (inklusive erweiterte Felder) werden komplett übernommen, wenn der aktuelle Nutzer diese Rolle nicht besitzt. Andernfalls werden fehlende Werte ergänzt.",
      contact_info_and_login:
        "Der Login wird nur übernommen, wenn die aktuelle Person keinen Login besitzt. Kontaktinformationen müssen bei Bedarf vorab manuell übertragen werden.",
      transferred_label: "Übertragen werden:",
    },
  },
  invoice: {
    success: "Rechnungen wurden erfolgreich erstellt",
    error: "Fehler beim Generieren der Rechnungen",
    titles: {
      correction: "Korrektur zu Rechnung [%{invoiceNumber}]",
      reversal: "Stornierung der Rechnung [%{invoiceNumber}]",
      standard: "Rechnung",
    },
    correction_reversal: "Korrektur/Storno",
    success_delete: "Rechnung wurde erfolgreich gelöscht",
    error_delete: "Fehler beim Löschen der Rechnung",
    created_text:
      "Folgende Rechnungen wurden erfolgreich erstellt und können mit den Aktionen unten weiter verarbeitet werden.",
    overview_text: "Folgende Rechnungen können mit den Aktionen unten weiter verarbeitet werden.",
    send_to_accounting: "Übertragen",
    selected_with_non_uniq_event: "Die ausgewählten Rechnungen müssen alle zur selben Veranstaltung gehören",
  },
  show_detail_page: "Detailseite anzeigen",
  export: {
    error: "Export fehlgeschlagen",
    actions: {
      export: "Exportieren",
      resource: "%{resource} exportieren",
      event: "Veranstaltung",
      all_attendees: "Personen und Buchungen",
      all_lecturers: "Dozierende",
    },
    fields: {
      days: "Tage",
      all_valid_bookings_count: "Teilnahmezahl",
    },
  },
  history: {
    action: {
      change: "geändert",
      create: "hinzugefügt",
      delete: "entfernt",
      sent: "gesendet",
      sent_to: "an %{to} gesendet",
    },
    boolean_change: {
      is_bookable: {
        true: "buchbar gemacht",
        false: "unbuchbar gemacht",
      },
      high_priority: {
        true: "angeheftet",
        false: "losgelöst",
      },
      is_online: {
        true: "als Online-Veranstaltung markiert",
        false: "als Vor-Ort-Veranstaltung markiert",
      },
      is_public: {
        true: "veröffentlicht",
        false: "nicht öffentlich geschaltet",
      },
    },
    special_change: "von %{oldValue} auf %{newValue} geändert",
    deleted: "gelöscht",
    deleted_f: "gelöschte",
    deleted_m: "gelöschter",
    deleted_n: "gelöschtes",
    deleted_record: "Nicht gefunden (vermutlich gelöschter Datensatz): %{id}",
    fetch_error: "Historie konnte nicht geladen werden",
    field_change: "%{name}: %{oldValue} → %{newValue}",
    value_change: "%{oldValue} → %{newValue}",
    no_value: "Kein Wert",
    archived: "Archiviert",
    restored: "Wiederhergestellt",
    show_all: "Komplette Historie anzeigen",
  },
  permission_actions: {
    create: "Hinzufügen",
    read: "Ansehen",
    update: "Ändern",
    delete: "Löschen",
    update_debit_number: "Debitorennummer aktualisieren",
  },
  feedback: {
    thank_you_headline: "Vielen Dank",
    thank_you_description: "Vielen Dank für das wertvolle Feedback!",
  },
  titles: {
    event_base_child_create: "Angebot für %{name} erstellen",
    registration_date: "Anmeldezeitraum",
    timespan: "Zeitraum",
  },
  actions: {
    remove_from_group: "Aus Gruppe entfernen",
    remove_lecturer_from_event: "Aus Veranstaltung entfernen",
    reset_filters: "Filter zurücksetzen",
    select_all: "Alle auswählen",
    show_related_data: "Verknüpfte Inhalte anzeigen",
    show_all: "Alle anzeigen",
    show_all_errors: "%{smart_count} weiterer Fehler |||| %{smart_count} weitere Fehler",
    show_less: "Weniger anzeigen",
    send: "Absenden",
    edit_dashboard: "Dashboard bearbeiten",
  },
  info_page: {
    software_version: "Software-Version",
    support: "Support",
    support_mail: "service@priorist.com",
    release_notes: "Release-Notes",
    release_notes_link: "https://education-manager.de/releases",
    license: "Lizenz-Hinweise",
    license_info:
      "EDM verwendet hilfreiche Drittanbieter-Komponenten und -Bibliotheken. Wir sind den Autoren dieser Produkte dankbar, dass sie sie der Öffentlichkeit zur Verfügung stellen. Der folgende Abschnitt enthält die erforderlichen Lizenz-Hinweise für Bibliotheken von Drittanbietern, die in EDM enthalten sind:",
    is_licensed_under: "ist lizensiert unter",
  },
  femCount: "Eine %{entity} ist |||| %{count} %{entity} sind",
  error: "Fehler",
  not: "Nicht",
  by: "von",
  to: "an",
  at: "am",
  connected_with: "verknüpft mit",
  disconnect: "trennen",
  numbers: {
    2: "zwei",
    3: "drei",
    4: "vier",
    5: "fünf",
    6: "sechs",
    7: "sieben",
    8: "acht",
    9: "neun",
    decimalSeparator: ",",
    thousandSeparator: ".",
  },
  more: "mehr",
  countMore: "%{count} weitere",
  less: "weniger",
  today: "Heute",
  tomorrow: "Morgen",
  no_data: "Keine Daten vorhanden",
  reports: {
    title: "Auswertung",
    sales: "Umsatz",
    booking: "Buchung |||| Buchungen",
    sold_item: "Verkauf |||| Verkäufe",
    calendar_week_with_date: "KW %{kw} ab %{date}",
    bookings_and_sales: "Verkäufe und Umsatz",
    bookings_by_sales: "Verkaufspreise nach Umsatz",
    cancellation_by_events: "Stornierungsquote Veranstaltungen",
    event_status_chart: "Veranstaltungen nach Status",
    report_by_base_data: "Stammdaten",
    total_occupancy: "Gesamtauslastung",
    draft: "Entwurf",
    offered: "Angebot",
    takes_place: "Findet statt",
    finished: "Abgeschlossen",
    canceled: "Abgebrochen",
    sales_with_amount: "EUR %{amount},- Umsatz",
    best_offers: "Top Angebote",
    anchor: "Datum",
    anchor_order_date: "Bestelldatum",
    anchor_event_date: "Veranstaltungsdatum",
    date_from: "Von",
    date_to: "Bis",
    event_format: "Veranstaltungsformat",
    other: "Sonstige |||| Sonstiges",
    states: "Auswertung nach Bundesländern",
    by_sales: "nach Umsatz",
    by_bookings: "nach Verkäufen",
    event_charts: "Auswertungen",
    no_data_events: "In diesem Zeitraum sind keine Veranstaltungen vorhanden",
    no_data_bookings: "In diesem Zeitraum sind keine Buchungen vorhanden",
    no_data_event_bases: "In diesem Zeitraum sind keine Angebote gebucht worden",
    metrics: {
      cancellation: "Stornierung||||Stornierungen",
      events_carried_out: "Durchgeführte Veranstaltung||||Durchgeführte Veranstaltungen",
      events_upcoming: "Anstehende Veranstaltung||||Anstehende Veranstaltungen",
      average_price: "Durchschnittspreis",
      wating_ratio: "Wartelisten-Quote",
    },
  },
  dashboard: {
    title: "Dashboard",
    no_data_bookings: "Keine Buchungen vorhanden",
    bookings_overview: "Aktuelle Buchungen",
    bookings_by_type: "Teilnahmeübersicht",
    longest_waitinglist: "Längste Warteliste",
    registration_period_exceeded: "Anmeldezeitraum erreicht",
    booked_out: "Ausgebucht",
    show_own: "Nur meine",
    empty_timeline: "Keine Aktivitäten vorhanden",
    still_billable: "Noch abzurechnen",
    amount_open: "Offen",
    amount_total: "Gesamtbetrag",
    few_bookings_necessary: "Nur noch wenige Buchungen notwendig",
    takes_place: "findet statt",
    upcoming_events: "Kommende Veranstaltungen",
    timespan: "Zeitraum",
    in_room: "in Raum %{room}",
    more_lecturers: "... %{count} weitere",
    less_lecturers: "... weniger",
    valid: "Eingebucht",
    waiting: "Warteliste",
    canceled: "Storniert",
    search_event: "Veranstaltung suchen",
    recent_edited: "Zuletzt bearbeitet",
    recent_orders: "Letzte Bestellungen",
    filter: {
      today: "Heute",
      yesterday: "Gestern",
      next_seven_days: "Nächsten 7 Tage",
      next_thirty_days: "Nächsten 30 Tage",
      next_three_months: "Nächsten 3 Monate",
      last_seven_days: "Letzten 7 Tage",
      last_thirty_days: "Letzten 30 Tage",
      current_month: "Aktueller Monat",
      custom_range: "Eigener Zeitraum",
      last_three_months: "Letzten 3 Monate",
      last_six_months: "Letzten 6 Monate",
      this_year: "Dieses Jahr",
      last_year: "Letztes Jahr",
      penultimate_year: "Vorletztes Jahr",
      remaining_year: "Restliches Jahr",
    },
  },
  event_formats: {
    ONLINE: "Online",
    ONSITE: "Präsenz",
    HYBRID: "Hybrid",
    E_LEARNING: "E-Learning",
  },
  attendance_formats: {
    ONLINE: "Online",
    ONSITE: "Präsenz",
    HYBRID: "Hybrid",
  },
  email_scope_description: {
    NEW_MOODLE_ACCOUNT_TEMPLATE:
      "Wird automatisch verwendet, wenn eine Person mit einem Moodle-Account verknüpft wird und dabei ein neuer Moodle-Account angelegt wird. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    ENROLLMENT_APPROVAL_TEMPLATE:
      "Wird automatisch verwendet, wenn eine Anmeldung durch eine Freigabeperson genehmigt werden muss. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    ENROLLMENT_DENIED_TEMPLATE:
      "Wird automatisch verwendet, wenn eine Anmeldung durch eine Freigabeperson abgelehnt wurde. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    BOOKING_TEMPLATES: "Vorlagen, die im Kontext von Buchungen verwendet werden können.",
    BOOKING_CONFIRMATION_TEMPLATES:
      "Vorlagen, die zur Bestätigung einer erfolgreichen Buchung verwendet werden können, z. B. beim Verarbeiten der Anmeldung.",
    LECTURER_TEMPLATES: "Vorlagen, die bei der Kommunikation mit Dozierenden verwendet werden können.",
    CONSENT_TEMPLATES:
      "Vorlagen, die im Bereich Einwilligungstypen verwendet werden können – beispielsweise im Rahmen des Double-Opt-In-Prozesses zur Einholung oder Bestätigung von Zustimmungen, z. B. für den Portalzugang.",
    ENROLLMENT_CONFIRMATION_TEMPLATE:
      "Wird automatisch nach erfolgreicher Anmeldung (z. B. über die Webseite) zu einer Veranstaltung versendet. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    FEEDBACK_TEMPLATES: "Vorlagen, die beim Versenden von Feedbackbögen verwendet werden können.",
    NEW_ATTENDEE_TEMPLATE:
      "Wird automatisch verwendet, wenn über die EDM-Oberfläche ein Login für Personen oder Dozierende hinterlegt wird. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    NEW_STAFF_MEMBER_TEMPLATE:
      "Wird automatisch verwendet, wenn über die EDM-Oberfläche ein Login für Mitarbeitende hinterlegt wird. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    ATTENDEE_TEMPLATES:
      "Vorlagen, die bei der Kommunikation mit Personen verwendet werden können. Wichtig: Diese Vorlagen sind nicht im Buchungskontext verfügbar, sondern nur im Personenkontext.",
    LECTURER_BOOKING_TEMPLATES:
      "Vorlagen, die im Portal von Dozierenden genutzt werden können, um mit Teilnehmenden zu kommunizieren.",
    INVOICE_TEMPLATES: "Vorlagen, die im Kontext von Rechnungen verwendet werden können.",
    PASSWORD_RESET_TEMPLATE:
      "Wird automatisch verwendet, um einen Link zum Zurücksetzen des Passworts zu versenden. Für diesen Bereich darf nur eine Vorlage hinterlegt werden.",
    ATTENDANCE_CONFIRMATION_TEMPLATES:
      "Vorlagen, die beim Versenden von Teilnahmebestätigungen verwendet werden können.",
    WAITING_LIST_TEMPLATES:
      "Vorlagen, die zur Bestätigung einer Wartelistenbuchung verwendet werden können, z. B. beim Verarbeiten der Anmeldung.",
    ORDER_CONFIRMATION_TEMPLATE:
      "Wird automatisch an die bestellende Person gesendet, wenn eine Bestellung eingeht. Für diesen Bereich kann nur eine Vorlage zugewiesen werden.",
    ORDER_ITEM_APPROVAL_TEMPLATE:
      "Wird automatisch versendet, um eine externe Genehmigung für eine Bestellposition anzufordern. Für diesen Bereich kann nur eine Vorlage zugewiesen werden.",
    ORDER_ITEM_DENIED_TEMPLATE:
      "Wird automatisch versendet, wenn die Genehmigung einer Bestellposition abgelehnt wird. Für diesen Bereich kann nur eine Vorlage zugewiesen werden.",
    ORDER_TEMPLATES:
      "Vorlagen, die im Kontext von Bestellungen verwendet werden können, z. B. für E-Mails an die bestellende Person oder Organisation.",
    ORGANIZATION_TEMPLATES: "Vorlagen, die bei der Kommunikation mit Organisationen verwendet werden können.",
    USER_TEMPLATES:
      "Vorlagen, die bei der Kommunikation mit Personen verwendet werden können. Die Teilnehmenden-Rolle und ihre Zusatzfelder stehen hier nicht zur Verfügung; dafür den Bereich „Teilnehmende“ verwenden.",
    BOOKING_CANCELLATION_REQUEST:
      "Wird automatisch an die Stornierungskontakt-E-Mail aus den Einstellungen gesendet, wenn eine Person im Portal eine Stornierung anfragt. Ohne diese Vorlage sind keine Stornierungsanfragen möglich. Für diesen Bereich kann nur eine Vorlage zugewiesen werden.",
    BOOKING_CANCELLATION_RECEIVED:
      "Wird automatisch an die Person gesendet, die eine Stornierung angefragt hat, um den Eingang der Anfrage zu bestätigen. Für diesen Bereich kann nur eine Vorlage zugewiesen werden.",
    EVENT_LOCATION_TEMPLATES:
      "Vorlagen, die bei der Kommunikation mit Veranstaltungsorten verwendet werden können. Versendet wird an die E-Mail-Adresse des Veranstaltungsortes.",
    INTEREST_TEMPLATES:
      "Vorlagen für die Kommunikation mit Interessierten an einem Angebot oder einer Veranstaltung. Es wird beim Eingang eines Interesses keine E-Mail automatisch versendet.",
  },
  permissions_description: {
    default:
      "Dashboard (ohne Noch abzurechnen) / Veranstaltungen inkl. Buchungen einsehen / Angebote einsehen / Personen einsehen / Interessierte einsehen / Dozierende einsehen / Datensätze exportieren / Notizen einsehen / Historie einsehen",
    manage_events:
      "Veranstaltungen anlegen, bearbeiten und archivieren / Veranstaltungs-Termine anlegen, bearbeiten und löschen / Veranstaltungs-Preise anlegen, bearbeiten und löschen / Veranstaltungs-Dokumente anlegen, bearbeiten und löschen / Veranstaltungs-Notizen anlegen, bearbeiten und löschen / Veranstaltungs-Funktionen (z.B. Status ändern, Duplizieren, Gruppe zuweisen, Angebot ändern)",
    manage_event_bases:
      "Angebote anlegen, bearbeiten und archivieren / Angebots-Beschreibungen anlegen, bearbeiten und löschen / Angebots-Dokumente anlegen, bearbeiten und löschen / Angebots-Notizen anlegen, bearbeiten und löschen / Angebots-Funktionen (z.B. Angebotstyp ändern, Duplizieren)",
    manage_orders:
      "Bestellungen anlegen, bestätigen, stornieren und verarbeiten / Bestellpositionen buchen und zuweisen / Rechnungen zu Bestellungen erstellen / E-Mail-Versand",
    manage_users:
      "Personen anlegen, bearbeiten und archivieren / Kontaktdaten anlegen, bearbeiten und löschen / Schlagworte anlegen, bearbeiten und löschen",
    manage_attendees:
      "Personen anlegen, bearbeiten und archivieren / Kontaktdaten von Personen anlegen, bearbeiten und löschen / Personen-Dokumente anlegen, bearbeiten und löschen / Personen-Notizen anlegen, bearbeiten und löschen / Personen-Funktionen (z.B. Zusammenführen, Login anlegen) / E-Mail-Versand",
    manage_organizations: "Organisationen anlegen, bearbeiten und löschen. Personen zu Organisationen hinzufügen",
    manage_interests: "Interessierte anlegen, bearbeiten und löschen",
    manage_lecturers:
      "Dozierende anlegen, bearbeiten und archivieren / Kontaktdaten von Dozierenden anlegen, bearbeiten und löschen / Dozierende-Dokumente anlegen, bearbeiten und löschen / Dozierende-Notizen anlegen, bearbeiten und löschen / Dozierende-Funktionen (z.B. Zusammenführen, Login anlegen) / E-Mail-Versand",
    manage_todos_and_responsibilities:
      "Aufgaben innerhalb einer Veranstaltung anlegen, bearbeiten und löschen / Zuständigkeiten innerhalb einer Veranstaltung anlegen, bearbeiten und löschen",
    manage_moodle:
      "Moodle-Kurse verknüpfen, anlegen und löschen / Moodle-Accounts verknüpfen, anlegen und löschen / Moodle-Einbuchungen anlegen und löschen",
    manage_bookings:
      "Buchungen anlegen, bearbeiten und löschen / Buchungs-Dokumente anlegen, bearbeiten und löschen / Rechnungen einsehen / E-Mail-Versand",
    manage_invoices:
      'Rechnungen (inkl. Korrektur- und Stornorechnungen) anlegen, bearbeiten und löschen / Rechnungen versenden / Anzeige von "noch abzurechnen" auf Dashboard',
    view_accounting: "EDM-Abrechnung einsehen",
    view_reporting: "Auswertung einsehen",
    view_booking_list: "Menüpunkt Buchungsliste einsehen",
    view_invoice_list: "Menüpunkt Rechnungsliste einsehen",
    manage_accounting:
      "Rechnungen übertragen (z.B. an ScopeVisio) / Debitorennummer von Personen und Konto-Felder von Veranstaltungen einsehen und bearbeiten / Buchungen als bezahlt markieren",
    manage_access:
      "Mitarbeitende anlegen, bearbeiten und archivieren / Berechtigungsgruppen anlegen, bearbeiten und löschen / OAuth-Applikationen anlegen, bearbeiten und löschen",
    manage_templates:
      "E-Mail Templates anlegen, bearbeiten und löschen / E-Mail Absender anlegen, bearbeiten und löschen / Dokumentenvorlagen anlegen, bearbeiten und löschen / Zuständigkeiten anlegen, bearbeiten und löschen / Erweiterte Felder anlegen, bearbeiten und löschen / Aufgabenlisten anlegen, bearbeiten und löschen",
    manage_settings:
      "Allgemeine Einstellungen bearbeiten / Preistypen anlegen, bearbeiten und löschen / Umgebungen anlegen, bearbeiten und löschen / Angebotstypen anlegen, bearbeiten und löschen / Verknüpfte Applikationen aktivieren und deaktivieren",
    manage_base_data:
      "Veranstaltungsorte anlegen, bearbeiten und löschen / Kooperationspartner anlegen, bearbeiten und löschen / Zielgruppen anlegen, bearbeiten und löschen / Kategorien anlegen, bearbeiten und löschen / Schlagworte anlegen, bearbeiten und löschen",
    manage_event_feedback:
      "Feedbackbogen für Veranstaltung hinterlegen / Veranstaltungsspezifische Feedback-Auswertung einsehen",
    view_feedback_report: "Allgemeine Feedback-Auswertung einsehen",
  },
  portal: {
    welcome: "Herzlich willkommen!",
    logged_in_as: "Angemeldet als",
    your_bookings: "Meine Buchungen",
    your_orders: "Ihre Bestellungen",
    your_open_orders: "Offene Bestellungen",
    your_interests: "Meine persönlichen Favoriten",
    your_events: "Meine Veranstaltungen",
    your_organizations: "Meine Organisationen",
    create_organization: "Organisation anlegen",
    no_organizations: "Noch keine Organisation zugeordnet.",
    show_past_bookings: "Vergangene Buchungen",
    show_past_events: "Vergangene Veranstaltungen",
    event_canceled: "Diese Veranstaltung wurde storniert",
    booking_waitinglist: "Auf der Warteliste",
    booking_canceled: "Diese Buchung wurde storniert",
    missing_consent:
      "Die E-Mail-Adresse wurde noch nicht bestätigt. Erst nach erfolgter Bestätigung ist die Nutzung der Portal-Funktionen möglich. Falls keine Verifizierungs-E-Mail eingegangen ist oder eine neue benötigt wird, bitte den untenstehenden Button verwenden.",
    confirm_your_email: "E-Mail-Adresse bestätigen",
    resend_verification_mail: "Bestätigungs-E-Mail erneut senden",
  },
  languages: {
    de: "Deutsch",
    en: "Englisch",
    fr: "Französisch",
    es: "Spanisch",
  },
  admin: {
    descriptions: {
      event_locations: "Standorte und Räume verwalten",
      partners: "Partnerdaten samt Beschreibung hinterlegen",
      audiences: "Zielgruppen für Angebote definieren",
      categories: "Themenrubriken gliedern und pflegen",
      tags: "Tags für Suche und Filter anlegen",
      user_lists: "Personen und Kontakte in Listen pflegen und verwalten",

      staff_members: "Accounts administrieren und Rechte verwalten",
      user_roles: "Rechte definieren und zuordnen",
      o_auth_apps: "Externe Apps registrieren und Tokens verwalten",
      subscriptions: "Webhooks für verschiedene Ereignisse verwalten",

      email_senders: "Absenderprofile und Signaturen konfigurieren",
      external_email_templates: "Standardmails gestalten und versionieren",
      custom_field_content_types: "Zusatzattribute modellieren",
      responsibility_types: "Verantwortliche je Angebotstyp festlegen",
      todo_lists: "Checklisten erstellen und als Vorlage definieren",
      document_templates: "Office-Layouts hochladen, Platzhalter setzen",
      invoice_templates: "Design inkl. E-Rechnung konfigurieren",
      feedback_forms: "Fragebögen konzipieren und verwalten",

      settings: "Globale Parameter und Branding anpassen",
      event_types: "Typen samt Beschreibungsfeldern definieren",
      customer_invoices: "Nutzungsabrechnung des Education Managers einsehen",
      customer: "Organisations- und Kontaktdaten konfigurieren",
      price_types: "Preisvarianten und Rabatte pflegen",
      contexts: "Abgrenzung der Bildungsangebote",
      tax_rates: "Steuersätze verwalten",
      integrated_applications: "Integrationen einsehen",
      consent_types: "Zustimmungskategorien laut DSGVO pflegen",
      settings_general: "Parameter, Links und E-Mail-Einstellungen konfigurieren",
      settings_portal: "Portal einrichten und Dozierendenzugang steuern",
      settings_defaults: "Standardwerte für neue Veranstaltungen festlegen",
      settings_storefront: "Storefront-Konfiguration anpassen",
      settings_orders: "Bestellprüfungen, Checkout-Verhalten und Rechnungsstellung konfigurieren",
    },
  },
  mdx: {
    dialogControls: {
      save: "Speichern",
      cancel: "Abbrechen",
    },
    createLink: {
      url: "URL",
      urlPlaceholder: "URL auswählen oder einfügen",
      title: "Titel",
      saveTooltip: "URL setzen",
      cancelTooltip: "Bearbeitung abbrechen",
    },
    linkPreview: {
      open: "%{url} in einem neuen Fenster öffnen",
      edit: "Link URL Bearbeiten",
      copyToClipboard: "In Zwischenablage kopieren",
      copied: "Kopiert!",
      remove: "Link entfernen",
    },
    toolbar: {
      blockTypes: {
        paragraph: "Absatz",
        quote: "Zitat",
        heading: "Überschrift %{level}",
      },
      blockTypeSelect: {
        selectBlockTypeTooltip: "Blocktyp auswählen",
        placeholder: "Blocktyp",
      },
      toggleGroup: "Gruppe umschalten",
      removeBold: "Fettdruck entfernen",
      bold: "Fettdruck",
      removeItalic: "Kursivdruck entfernen",
      italic: "Kursivdruck",
      underline: "Unterstreichung entfernen",
      removeUnderline: "Unterstreichung",
      removeInlineCode: "Codeformat entfernen",
      inlineCode: "Inline Codeformatierung",
      link: "Link erstellen",
      richText: "Rich text",
      diffMode: "Differenzmodus",
      source: "Quellenmodus",
      admonition: "Call-out einfügen",
      codeBlock: "Codeblock einfügen",
      editFrontmatter: "Titelei bearbeiten",
      insertFrontmatter: "Titelei einfügen",
      image: "Bild einfügen",
      insertSandpack: "Sandpack einfügen",
      table: "Tabelle einfügen",
      thematicBreak: "Themenbruch einfügen",
      bulletedList: "Strickpunktliste",
      numberedList: "Nummerierte Liste",
      checkList: "Checkliste",
      deleteSandpack: "Diesen Codeblock löschen",
      undo: "Rückgängig %{shortcut}",
      redo: "Wiederholen %{shortcut}",
      highlight: "Markieren",
      removeHighlight: "Markierung entfernen",
    },
    contentArea: {
      editableMarkdown: "bearbeitbares markdown",
    },
    parseError:
      "Es ist ein Fehler beim Anzeigen des Inhalts aufgetreten. Der Inhalt enthält möglicherweise ungültige Formatierungen.",
  },
  event_date_planner: {
    series_toggle: "Terminserie hinzufügen",
    time_toggle: "Uhrzeit angeben",
    details_toggle: "Weitere Termindetails",
    no_existing_dates: "Keine Termine vorhanden",
    existing_dates: "Termin anzeigen |||| %{smart_count} Termine anzeigen",
    add_dates: "Termine hinzufügen",
    already_planned:
      "%{smart_count} Tag hat bereits einen Termin und wurde übersprungen: %{days} |||| %{smart_count} Tage haben bereits einen Termin und wurden übersprungen: %{days}",
    save_planned_dates: "Speichern",
    remove_all_dates: "Alle Termine entfernen",
    planned_dates: "%{smart_count} Termin hinzufügen |||| %{smart_count} Termine hinzufügen",
    every: "alle",
    weeks: "Woche(n)",
    months: "Monat(e)",
    days: "Tag(e)",
    years: "Jahr(e)",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    daily: "Täglich",
    on: "Bis zum",
    after: "Nach x mal",
    single_date: "Einzeltermine",
    rrule: {
      name: "Serientermine",
      interval: "Interval",
      start: "Start",
      frequency: "Frequenz",
      end_condition: "Endet",
      end_date: "Enddatum",
      end_count: "Wiederholungen",
    },
    weekdays: {
      monday: "Mo",
      tuesday: "Di",
      wednesday: "Mi",
      thursday: "Do",
      friday: "Fr",
      saturday: "Sa",
      sunday: "So",
    },
  },
};

export default germanMessages;
